/*** Pre Declare Filter Arrays ***/
const cut_array = {"Excellent": "Excellent","Very Good": "Very Good","Good": "Good"};

const clarity_array = {"Eye Clean": "Eye Clean","Slightly Included": "Slightly Included","Moderately Included": "Moderately Included","Visibly Included": "Visibly Included","Any": "Any"};
/*** End ***/

/**** Advanced Filter Functionality Start ****/  
$(document).on("click", ".tps-advanced-filter-btn", function() {
    var filter_category = jQuery(this).attr("data-category");
    
    if(jQuery(this).hasClass("active")){
      jQuery(this).removeClass("active");
      jQuery('.tps-advanced-filter-btn').html(translations.titleAdvancedFilters+' <span class="tps-arrow-down"></span>'); 
      jQuery('.tps-filter-'+filter_category).slideUp('slow');    
    }else{
      jQuery(this).addClass("active");
      jQuery('.tps-advanced-filter-btn').html(translations.titleHideFilters+' <span class="tps-arrow-up"></span>');      
      jQuery('.tps-filter-'+filter_category).slideDown('slow');    
    }      
});
/*** End ***/

/*** Advance Filters Hide Show Functionality Strat ***/
$(document).on("click", ".tps-checkbox-filter-heading-wrapper", function() {
  var data_filter = jQuery(this).attr("data-filter");
  if(jQuery(this).hasClass("active")){
    jQuery(this).removeClass("active");
    jQuery('.tps-'+data_filter+'-filter-wrapper').slideUp('slow'); 
    jQuery('.tps-filter-'+data_filter+' .tps-arrow').addClass('tps-arrow-down').removeClass('tps-arrow-up'); 
  }else{
    jQuery('.tps-checkbox-filter-heading-wrapper').removeClass("active");
    jQuery('.tps-checkbox-filter-wrapper').slideUp('slow');
    jQuery('.tps-slider-filter-wrapper').slideUp('slow');    
    jQuery('.tps-arrow').removeClass('tps-arrow-up').addClass('tps-arrow-down'); 
    
    jQuery(this).addClass("active");
    jQuery('.tps-'+data_filter+'-filter-wrapper').slideDown('slow'); 
    jQuery('.tps-filter-'+data_filter+' .tps-arrow').removeClass('tps-arrow-down').addClass('tps-arrow-up'); 
  }
  
});
/*** End ***/

/*** Advanced Filter & Reset Filter Popoup Close Outer Click Start ***/
jQuery(document).on('click','#MainContent',function(e){
  var container = $(".tps-filter-section-block");
  var container2 = $(".tps-advanced-reset-button-section"); //filter tab container
  var container3 = $(".tps-tab2");
    
  // If the target of the click isn't the container
  if(!container.is(e.target) && container.has(e.target).length === 0 && !container2.is(e.target) && container2.has(e.target).length === 0 && !container3.is(e.target) && container3.has(e.target).length === 0){      
    jQuery('.tps-checkbox-filter-heading-wrapper').removeClass("active");
    jQuery('.tps-checkbox-filter-wrapper').slideUp('slow');
    jQuery('.tps-slider-filter-wrapper').slideUp('slow');    
    jQuery('.tps-arrow').removeClass('tps-arrow-up').addClass('tps-arrow-down'); 

    jQuery(".tps-reset-filter-confirm-popup-div").hide();
  }
});
/*** Advanced Filter & Reset Filter Popoup Close Outer Click End ***/

/**** Mobile Filter Open/Close Start ****/ 
function mobileFilters(action){  
  if(action == 'open'){
    $(".tps-filter-container").addClass('tps-mobile-filters');
    $('body').addClass('tps-mobile-filters-open');
  }else{
    $(".tps-filter-container").removeClass('tps-mobile-filters');
    $('body').removeClass('tps-mobile-filters-open');
  }  
}
/*** End ***/

/**** Mobile Filter Button Sticky Start ****/ 
$(window).scroll(function(){
    if ($(this).scrollTop() > 500) {
       $('.tps-mobile-filter-button-section').addClass('tps-sticky-btn');
    } else {
       $('.tps-mobile-filter-button-section').removeClass('tps-sticky-btn');
    }
});
/*** End ***/

/**** Tooltip Information Open/Close Start ****/ 
function infoPopup(diamondField,action){  
  if(action == 'open'){
    $(".tps-gemstone-field-"+diamondField).addClass('tps-popup-info-show');    
  }else{
    $(".tps-gemstone-field-"+diamondField).removeClass('tps-popup-info-show');    
  }  
}
/**** Tooltip Information Open/Close End ****/ 

/*** Diamond Filter Tooltip Info Popoup Close Outer Click Start ***/
jQuery(document).on('click','.tps-popup-info-show',function(e){
  var container = $(".tps-gemstone-field-popup-section");
    
  // If the target of the click isn't the container
  if(!container.is(e.target) && container.has(e.target).length === 0){      
    jQuery(".tps-gemstone-field-popup-wrapper").removeClass("tps-popup-info-show");
  }
});
/*** Diamond Filter Tooltip Info Popoup Close Outer Click End ***/

/*** CheckBox Type Filter Selection Common Function Start ***/
function setCheckboxtypeFilter(ele,parentClass,valueid,filter){  
   var filter_value = jQuery(ele).find("input").attr('data-value');
   emptyResultDiv();
   if(jQuery(ele).hasClass('selected')){
      jQuery(ele).removeClass('selected');
   }else{
      jQuery(ele).addClass('selected');
   }
    
   var check_variable='';
  
    jQuery("."+parentClass+" input:checkbox" ).each(function(){
      if(jQuery(this).is(':checked')){
        if(check_variable==""){
          check_variable = jQuery(this).attr('value'); 
        }else{
          check_variable = check_variable+","+jQuery(this).attr('value');
        }            
      }
    });
    if(check_variable==''){
      $('#'+valueid).val('');
    }else{      
      $('#'+valueid).val(check_variable);
    }
    
    jQuery('#page_no').val(1);
    jQuery('#pagination').val('');
    graphqlDataCall();
    updateSessionFilters(session_variable+'-filters',filter, check_variable);
  
    //Applied filter code start 
    var filterTitle = filter+': '+filter_value;
    var filterFunction = "remove"+filter+"Filter('"+filter_value+"')"; 
    var hasClass = jQuery(ele).hasClass('selected');
    setSelectedFilter(filterTitle,filterFunction,hasClass,filter_value);
    //end

    jQuery('.tps-checkbox-filter-wrapper').slideUp('slow'); 
}
/*** End ***/

/*** Remove Shape Filter From Applied Filter Start ***/
function removeShapeFilter(shape){ 
  jQuery('.tps-filter-shape-list input[data-value="'+shape+'"]').click();
}
/*** Remove Shape Filter From Applied Filter End ***/

/*** Remove Fancy COlor Filter From Applied Filter Start ***/
function removeColourFilter(color){ 
  jQuery('.tps-filter-fancy-color-list input[data-value="'+color+'"]').click();
}
/*** Remove Fancy COlor Filter From Applied Filter End ***/

/*** Remove Origin Filter From Applied Filter Start ***/
function removeOriginFilter(origin){  
  jQuery('.tps-filter-origin-list input[data-value="'+origin+'"]').click();
}
/*** Remove Origin Filter From Applied Filter End ***/

/*** Remove Report Filter From Applied Filter Start ***/
function removeReportFilter(lab){  
  jQuery('.tps-filter-report-list input[data-value="'+lab+'"]').click();
}
/*** Remove Report Filter From Applied Filter End ***/

/*** Remove Type Filter From Applied Filter Start ***/
function removeTypeFilter(type){  
  jQuery('.tps-filter-type-list input[data-value="'+type+'"]').click();
}
/*** Remove Type Filter From Applied Filter End ***/

/*** Remove Treatment Filter From Applied Filter Start ***/
function removeTreatmentFilter(treatment){  
  jQuery('.tps-filter-treatment-list input[data-value="'+treatment+'"]').click();
}
/*** Remove Treatment Filter From Applied Filter End ***/

/*** Clarity Range Slider Filter Start ***/
function clarity_slider_render(start,end,option,filterTitle){
  //dynamic style left % 
  var claritySlot = 100/default_max_clarity;
  for (n = 1; n < default_max_clarity; n++) {
    var claritySoltLeft = n*claritySlot;
    jQuery(".tps-clarity-range-"+n).css("left", claritySoltLeft+"%");
  }
  
  var filterLabel = filterTitle+':'; 
  
  //session clarity filter selected
  var isSelected = false;
  if(start != 0 || end != default_max_clarity){
     isSelected = true;
  }

  var selected_values = getFilterValues(min_clarity,max_clarity,'clarity');
  if(selected_values[0] == selected_values[1]){
    var filterValues = filterLabel+' '+selected_values[1];
  }else{
      var filterValues = filterLabel+' '+selected_values[0]+' - '+selected_values[1];
  }
  setSelectedFilter(filterValues,"clarity_slider_render('0', '"+default_max_clarity+"','false','')",isSelected,'clarity');
  //end

    jQuery("#tps_clarity_range_slider").slider({ 
       range: true,
       values: [start, end],
       min: 0,
       max: default_max_clarity,
       step: 1, 
       slide: function( event, ui ) {          
          if ((ui.values[0]) >= (ui.values[1])) {
            return false;
          }
             
          jQuery("#clarity_min_value").val(ui.values[0]);
          jQuery("#clarity_max_value").val(ui.values[1]);           
      },
      change: function( event, ui ) {  
         var resetFlag = checkResetFlag();
         emptyResultDiv();
        
         jQuery("#clarity_min_value").val(ui.values[0]);
         jQuery("#clarity_max_value").val(ui.values[1]);
        
         //applied filters 
         var isSelected = false;         
         if(ui.values[0] != 0 || ui.values[1] != default_max_clarity){
               isSelected = true;
         }          
         var selected_values = getFilterValues(ui.values[0],ui.values[1],'clarity');
          
         if(selected_values[0] == selected_values[1]){
            var filterValues = translations.titleClarity+': '+selected_values[1];    
         }else{
            var filterValues = translations.titleClarity+': '+selected_values[0]+' - '+selected_values[1];    
         }          
          
         setSelectedFilter(filterValues,"clarity_slider_render('0', '"+default_max_clarity+"','false','')",isSelected,'clarity');
         updateSessionFilters(session_variable+'-filters',filterTitle,ui.values[0]+","+ui.values[1]);
         //end

         if(resetFlag != 'true'){
          jQuery('#page_no').val(1);
          jQuery('#pagination').val('');
          graphqlDataCall();
         }
        return false;
      }
   });
}
/*** End ***/

/*** Diamond Carat Filter Start ***/
function getCaratCalibArray(minDiamondCarat,maxDiamondCarat) {
  var carat = [];
  for (i = parseFloat(minDiamondCarat); i < parseFloat(maxDiamondCarat); i = i + 0.01) {
    var dec = i.toFixed(2);
    carat.push(dec);
  }  
  // for (i = 1; i < parseFloat(maxDiamondCarat); i = i + 0.1) {
  //  var dec = i.toFixed(2);
  //  carat.push(dec);
  // }
  carat.push(maxDiamondCarat);
  return carat;
}
  
function carat_slider_render(min_carat, max_carat, option, filterLabel) { 
    var carat = getCaratCalibArray(default_carat_min,default_carat_max);
  
    var minCarat = getClosestNum(min_carat, carat);
  var maxCarat = getClosestNum(max_carat, carat);   
  var carat_min = get_index(minCarat, carat); 
  var carat_max = get_index(maxCarat, carat);      
  
    var isSelected = false;       
    //session carat filter selected         
     if(parseFloat(min_carat) != default_carat_min || parseFloat(max_carat) != default_carat_max){
       isSelected = true;
     }            
    var caratFilterUnit = "ct.";
    var filterValues = filterLabel+': '+min_carat + ' '+caratFilterUnit+' - '+max_carat + ' '+caratFilterUnit;
       
     setSelectedFilter(filterValues,"carat_slider_render('"+default_carat_min+"', '"+default_carat_max+"','true','"+filterLabel+"')",isSelected,'carat');
     //end
  
  jQuery("#tps_carat_slider").slider({      
    range: true,
    min: 0,
    max: carat.length - 1,
    values: [carat_min, carat_max],
        step: 1,
    slide: function(event, ui) {    
            emptyResultDiv();          
      if ((ui.values[0] > ui.values[1])) {
        return false;
      }
                
      $("#carat_from").val(carat[parseInt(ui.values[0])]+' '+caratFilterUnit);
      $('#carat_left_hidden').val(carat[parseInt(ui.values[0])]);
      $('#carat_to').val(carat[parseInt(ui.values[1])]+' '+caratFilterUnit);
      $('#carat_right_hidden').val(carat[parseInt(ui.values[1])]);          
    },
    change: function(event, ui) {   
            var resetFlag = checkResetFlag();
            emptyResultDiv();
      if ((ui.values[0] > ui.values[1])) {
        return false;
      }     

      if (option) {                 
         
                //applied filter code start here      
                              
                 var isSelected = false;                        
                 if(carat[parseInt(ui.values[0])] != parseFloat(default_carat_min) || carat[parseInt(ui.values[1])] != parseFloat(default_carat_max)){
                       isSelected = true;
                 }    
                                    
                  var caratLeft = carat[parseInt(ui.values[0])];
                  var caratRight = carat[parseInt(ui.values[1])];

                  $("#carat_from").val(caratLeft+' '+caratFilterUnit);
                  $('#carat_left_hidden').val(caratLeft);
                  $('#carat_to').val(caratRight+' '+caratFilterUnit);
                  $('#carat_right_hidden').val(caratRight);                       
                             
                  var filterValues = filterLabel+': '+caratLeft+ ' '+caratFilterUnit+' - '+caratRight+ ' '+caratFilterUnit;
                   
                  setSelectedFilter(filterValues,"carat_slider_render('"+default_carat_min+"', '"+default_carat_max+"','true','"+filterLabel+"')",isSelected,'carat');
                  //end 

                  updateSessionFilters(session_variable+'-filters',filterLabel, caratLeft+","+caratRight);
                  if(resetFlag != 'true'){
                    jQuery('#page_no').val(1);
              jQuery('#pagination').val('');  
                    graphqlDataCall(); 
                  }                    
      }
           
    }

  });
    
    min_carat = min_carat ? min_carat : default_carat_min;
    $("#carat_from").val(min_carat+' '+caratFilterUnit);
    $("#carat_to").val(max_carat+' '+caratFilterUnit);
    $('#carat_left_hidden').val(min_carat);
    $('#carat_right_hidden').val(max_carat);    
}

function replace_carat_from(ele,min_carat,filterLabel) {   
  var settingSelected = $("#setting").val();
    var caratFilterUnit = "ct.";
  if ($('#carat_from').val() == '') {
    var value = parseFloat($('#carat_left_hidden').val()).toFixed(2);
    $('#carat_from').val(parseFloat(value).toFixed(2)+' '+caratFilterUnit);
    return false;
  } else {
    var hidden_carat_value = parseFloat($('#carat_left_hidden').val()).toFixed(2);
    var carat_value = parseFloat($('#carat_from').val()).toFixed(2);
  }
  
    var carat_min_value = parseFloat($('#carat_from').val());
  var carat_max_value = parseFloat($('#carat_to').val());
 
  if (isNaN(carat_min_value) != false) {
        value = parseFloat(default_carat_min).toFixed(2); 
        alert(translations.titlePleaseEnterValueInNumber);        
    $('#carat_from').val(value +' '+caratFilterUnit);
  } else if (carat_min_value > carat_max_value) { 
        alert(translations.titleIncorrectCaratRange);
    $('#carat_from').val(parseFloat(hidden_carat_value).toFixed(2)+' '+caratFilterUnit);
    return false;
  } else if (carat_value < default_carat_min) { 
        alert(translations.titleIncorrectCaratRange);
    $('#carat_from').val((parseFloat(default_carat_min).toFixed(2))+" "+caratFilterUnit);
    carat_slider_render(default_carat_min, carat_max_value, true,filterLabel);
    return false;
  } else if (settingSelected == 1 && (hidden_carat_value > carat_value)) { 
        alert(translations.titleCanMatchWithDiamond+' '+carat_value);       
    $('#carat_from').val(hidden_carat_value+" "+caratFilterUnit);
    return false;
  }
  $('#carat_left_hidden').val(carat_min_value);
  $('#carat_right_hidden').val(carat_max_value);
    
  carat_slider_render(carat_min_value, carat_max_value, true, filterLabel);
}

function replace_carat_to(ele,max_carat,filterLabel) {  
  var settingSelected = $("#setting").val();
    var caratFilterUnit = "ct.";
  if ($('#carat_to').val() == '') {
    var value = parseFloat($('#carat_right_hidden').val()).toFixed(2);
    $('#carat_to').val(parseFloat(value).toFixed(2)+' '+caratFilterUnit);
    return false;
  } else {
    var hidden_carat_value = parseFloat($('#carat_right_hidden').val()).toFixed(2);
    var carat_value = parseFloat($('#carat_to').val()).toFixed(2);
  } 
  
    var carat_max_value = parseFloat($('#carat_to').val());
  var carat_min_value = parseFloat($('#carat_from').val());
    
  if (isNaN(carat_max_value) != false) {
    var value = parseFloat(maxDiamondCarat).toFixed(2); 
        alert(translations.titlePleaseEnterValueInNumber);
    $('#carat_to').val(carat_max_value+' '+caratFilterUnit);
  } else if (parseFloat(carat_max_value) > parseFloat(default_carat_max)) { 
        alert(translations.titleIncorrectCaratRange);
    $('#carat_to').val(hidden_carat_value+" "+caratFilterUnit);
    return false;
  } else if (carat_min_value > carat_max_value) { 
        alert(translations.titleIncorrectCaratRange);
    $('#carat_to').val(hidden_carat_value+' '+caratFilterUnit);
    return false;
  }else if (settingSelected == 1 && (hidden_carat_value < carat_value)) {
        alert(translations.titleCanMatchWithDiamond+' '+carat_value);   
    $('#carat_to').val(hidden_carat_value+" "+caratFilterUnit);
    return false;
  }
   
  $('#carat_right_hidden').val(carat_max_value);
  $('#carat_left_hidden').val(carat_min_value);

  carat_slider_render(carat_min_value, carat_max_value, true, filterLabel);
}
/*** Diamond Carat Filter End ***/

/*** Diamond Price Filter End ***/
function getPriceCalibArray(minDiamondPrice,maxDiamondPrice) {
  var price = [];

  for (var i = parseInt(minDiamondPrice); i < 2500; i = i+1) {
    price.push(i);
  };
  for (var i = 2500; i < 5000; i = i+10) {
    price.push(i);
  };
  for (var i = 5000; i < 6000; i = i+15) {
    price.push(i);
  };
  for (var i = 6000; i < 7000; i = i+20) {
    price.push(i);
  };
  for (var i = 7000; i < 8000; i = i+25) {
    price.push(i);
  };
  for (var i = 8000; i < 9000; i = i+30) {
    price.push(i);
  };
  for (var i = 9000; i < 10000; i = i+35) {
    price.push(i);
  };
  for (var i = 10000; i < 15000; i = i+40) {
    price.push(i);
  };
  for (var i = 15000; i < 25000; i = i+50) {
    price.push(i);
  };
  for (var i = 25000; i < 50000; i = i+100) {
    price.push(i);
  };
  for (var i = 50000; i < 80000; i = i+200) {
    price.push(i);
  };
  for (var i = 80000; i < 100000; i = i+500) {
    price.push(i);
  };
  for (var i = 100000; i < 200000; i = i+1000) {
    price.push(i);
  };
  for (var i = 200000; i < 300000; i = i+1500) {
    price.push(i);
  };
  for (var i = 300000; i < 400000; i = i+2000) {
    price.push(i);
  };
  for (var i = 400000; i < 500000; i = i+2500) {
    price.push(i);
  };
  
  price.push(parseInt(maxDiamondPrice));
  return price;
}

function get_priceindex(price_min,price_max,value) {
    var price = getPriceCalibArray(price_min,price_max);
  var pos = 0
  for (i = 0; i < price.length; i++) {
    if (price[i] == value) {
      pos = i;
      break;
    }
  }
  return pos;
}

function price_slider_render(min_price,max_price,option,filterLabel){   
    var price = getPriceCalibArray(default_price_min,default_price_max);
  
    var minPrice = getClosestNum(min_price,price);
    var maxPrice = getClosestNum(max_price,price);  
    var price_min = get_priceindex(default_price_min,default_price_max,minPrice); 
    var price_max = get_priceindex(default_price_min,default_price_max,maxPrice);   

    //session price filter selected
    var isSelected = false;
    if(min_price != default_price_min || max_price != default_price_max){
       isSelected = true;
    }
    var filterValues = filterLabel+': '+Shopify.formatMoney(min_price*100, theme.moneyFormat)+' - '+Shopify.formatMoney(max_price*100, theme.moneyFormat);   
    setSelectedFilter(filterValues,"price_slider_render('"+default_price_min+"', '"+default_price_max+"','true','"+filterLabel+"')",isSelected,'price');
     //end
   
        jQuery("#tps_price_slider").slider({
            range: true,
            min: 0,
            max: price.length-1,
            values: [ price_min,price_max ],
            step:0.1,
            slide: function( event, ui ) { 
                if ((ui.values[0]) > (ui.values[1])) { 
                    return false; 
                }
                jQuery('#price_left_hidden').val(price[parseInt(ui.values[0])]);
                jQuery('#price_right_hidden').val(price[parseInt(ui.values[1])]);
    
                var price_form = ""+Shopify.formatMoney(price[parseInt(ui.values[0])]*100, theme.moneyFormat);
                jQuery('#price_from').val(price_form);
                var price_to = ""+Shopify.formatMoney(price[parseInt(ui.values[1])]*100, theme.moneyFormat);
                jQuery('#price_to').val(price_to);

                option = true;
            },
            change: function(event, ui) {
              var resetFlag = checkResetFlag();
              event.stopPropagation();
              emptyResultDiv();         
              if(option == true) {     
                 jQuery('#price_left_hidden').val(price[parseInt(ui.values[0])]);
                 jQuery('#price_right_hidden').val(price[parseInt(ui.values[1])]);
                
                 var price_form = ""+Shopify.formatMoney(price[parseInt(ui.values[0])]*100, theme.moneyFormat);
                 jQuery('#price_from').val(price_form);
                 var price_to = ""+Shopify.formatMoney(price[parseInt(ui.values[1])]*100, theme.moneyFormat);
                 jQuery('#price_to').val(price_to);
                  
                 //applied filters 
                 var isSelected = false;
                 
                 if(price[parseInt(ui.values[0])] != default_price_min || price[parseInt(ui.values[1])] != default_price_max){
                    isSelected = true;
                 }           
                
                 var filterValues = filterLabel+': '+price_form+' - '+price_to;          
                 
                 setSelectedFilter(filterValues,"price_slider_render('"+default_price_min+"', '"+default_price_max+"','true','"+filterLabel+"')",isSelected,'price');

                 updateSessionFilters(session_variable+'-filters',filterLabel, price[parseInt(ui.values[0])]+","+price[parseInt(ui.values[1])]);
                 //end      
                               
                  if(resetFlag != 'true'){
                    jQuery('#page_no').val(1);
                    jQuery('#pagination').val('');
                    graphqlDataCall();
                  }           
                  slide = '';
                  // event.stopPropagation();
                  return false;
              }else if(option == false) {
                   jQuery('#price_left_hidden').val(min_price);
                   jQuery('#price_right_hidden').val(max_price);
      
                   var price_form = ""+Shopify.formatMoney(min_price*100, theme.moneyFormat);
                   jQuery('#price_from').val(price_form);
                   var price_to = ""+Shopify.formatMoney(max_price*100, theme.moneyFormat);
                   jQuery('#price_to').val(price_to);

                   updateSessionFilters(session_variable+'-filters',filterLabel, min_price+","+max_price);  
                
                   if(resetFlag != 'true'){
                     jQuery('#page_no').val(1);
                     jQuery('#pagination').val('');
                     setTimeout(function(){
                       graphqlDataCall();
                     }, 10);
                   }else{                     
                     updateSessionFilters(session_variable+'-filters',filterLabel, default_price_min+","+default_price_max);  
                   }
                
                   setTimeout(function(){
                     option = true;
                   }, 25); 
                   slide = '';
                   
                   return false;
                }
              
            }
             
        });
        
      var start_num = parseInt(min_price);
      var end_num = parseInt(max_price);

      var start_dec = start_num.toFixed(0);
      var end_dec = end_num.toFixed(0);

     jQuery('#price_left_hidden').val(start_dec);
     jQuery('#price_right_hidden').val(end_dec);       
     jQuery('#price_from').val(Shopify.formatMoney(start_dec*100, theme.moneyFormat));  
     jQuery('#price_to').val(Shopify.formatMoney(end_dec*100, theme.moneyFormat));
}


/*** Price Validation Start ***/
$("#price_to").keypress(function(e) {
  //if the letter is not digit then display error and don't type anything
  if (e.which != 8 && e.which != 0 && (e.which < 48 || e.which > 57)) {        
    return false;
  }
});

$("#price_from").keypress(function(e) {
  //if the letter is not digit then display error and don't type anything
  if (e.which != 8 && e.which != 0 && (e.which < 48 || e.which > 57)) {  
    return false;
  }
});
/*** Price Validation End ***/

function replace_price_from(ele,priceMin,filterLabel) {   
  if (jQuery('#price_from').val() == '') {
    var value = parseFloat(jQuery('#price_left_hidden').val());          
        var formatted_max_price = ""+Shopify.formatMoney(value*100, theme.moneyFormat);
    jQuery('#price_from').val(formatted_max_price);
    return false;
  } else {
    var price_min = jQuery('#price_from').val();
  }
  
    var price_min_value = parseInt(getPriceWithoutSymbolAndCommas(price_min));
  var price_max_value = parseInt(jQuery('#price_right_hidden').val());
  
    var default_price_min_value = parseFloat(default_price_min);
    var formatted_min_price = ""+Shopify.formatMoney(default_price_min_value*100, theme.moneyFormat);
  
  if (isNaN(price_min_value) != false) {  
        alert(translations.titlePleaseEnterValueInNumber);  
    jQuery('#price_from').val(formatted_min_price);
        return false;
  } else if (price_min_value < default_price_min) {  
        alert(translations.titleIncorrectPriceRange);   
    jQuery('#price_from').val(formatted_min_price);
    return false;
  } else if (price_min_value > price_max_value) { 
        alert(translations.titleIncorrectPriceRange);        
    price_slider_render(default_price_min, price_max_value, false, filterLabel);
    return false;
  }

  jQuery('#price_left_hidden').val(price_min_value.toFixed(0));
  jQuery('#price_right_hidden').val(price_max_value.toFixed(0));
  price_slider_render(price_min_value, price_max_value, false, filterLabel);

}

function replace_price_to(ele,priceMax,filterLabel) {
  if ($('#price_to').val() == ''){
    var value = parseFloat($('#price_right_hidden').val());
        var formatted_min_price = ""+Shopify.formatMoney(value*100, theme.moneyFormat);
    $('#price_to').val(formatted_min_price);        
    return false;
  } else {
    var price_max = $('#price_to').val();        
  }

    var price_max_value = parseInt(getPriceWithoutSymbolAndCommas(price_max));
    var price_min_value = parseInt(jQuery('#price_left_hidden').val());

    var default_price_max_value = parseFloat(default_price_max);
    var formatted_max_price = ""+Shopify.formatMoney(default_price_max_value*100, theme.moneyFormat);
  
  if (isNaN(price_max_value) != false) {
        alert(translations.titlePleaseEnterValueInNumber);        
    jQuery('#price_to').val(formatted_max_price);
        return false;
  } else if (price_max_value > default_price_max) {         
        alert(translations.titleIncorrectPriceRange);
    jQuery('#price_to').val(formatted_max_price);        
    return false;
  } else if (price_min_value > price_max_value) {       
        alert(translations.titleIncorrectPriceRange);
    jQuery('#price_to').val(formatted_max_price);        
    return false;
  } else if (price_min_value == '') {
    jQuery('#price_from').val(price_min_value);
  }

  jQuery('#price_right_hidden').val(price_max_value.toFixed(0));
  jQuery('#price_left_hidden').val(price_min_value.toFixed(0));
  price_slider_render(price_min_value, price_max_value, false, filterLabel);
}

function getPriceWithoutSymbolAndCommas(input_price) {
  var price = input_price;
  if(input_price.indexOf("$") >= 0){
    price = input_price.replace('$', '');
    price = price.replace(/[^\d\.]/g, '');
  }else if(input_price.indexOf("€") >= 0){
    price = input_price.replace('€', '');
    price = price.replace(/\./g, '');   
  }
  return price;
}
/*** Diamond Price Filter End ***/

/*** Length Slider Filter Start ***/
function getLengthCalibArray(length_min,length_max) {  
  var length = [];
  for(i = parseFloat(length_min); i < parseFloat(length_max); i = i + 0.01){
    var dec = i.toFixed(2);
    length.push(dec);
  }  
  length.push(length_max);
  return length;
}

function length_slider_render(min_length, max_length, option, filterLabel) {
    var length = getLengthCalibArray(default_length_min,default_length_max);    
  var minLength = getClosestNum(min_length, length);
  var maxLength = getClosestNum(max_length, length);
  var length_min = get_index(minLength, length);  
  var length_max = get_index(maxLength, length);

    //session depth filter selected
     var isSelected = false;
     if(parseFloat(min_length) != parseFloat(default_length_min) || parseFloat(max_length) != parseFloat(default_length_max)){
       isSelected = true;
     }

     var filterValues = filterLabel+': '+min_length+' - '+max_length;
     setSelectedFilter(filterValues,"length_slider_render('"+parseFloat(default_length_min)+"', '"+parseFloat(default_length_max)+"','true','"+filterLabel+"')",isSelected,'length');
     //end
  
  jQuery("#tps_length_slider").slider({
    range: true,
    min: 0,
    max: length.length - 1,
    values: [length_min, length_max],
    slide: function(event, ui) {
      emptyResultDiv();
          
      if ((ui.values[0] > ui.values[1])) {
        return false;
      }

      $("#length_from").val(length[parseFloat(ui.values[0])]);
      $('#length_left_hidden').val(length[parseFloat(ui.values[0])]);
      $('#length_to').val(length[parseFloat(ui.values[1])]);
      $('#length_right_hidden').val(length[parseFloat(ui.values[1])]);
    },
    change: function(event, ui) {
            var resetFlag = checkResetFlag();
      emptyResultDiv();
          
      if ((ui.values[0] > ui.values[1])) {
        return false;
      }
      
      if (option) {
                $("#length_from").val(length[parseFloat(ui.values[0])]);
                $('#length_left_hidden').val(length[parseFloat(ui.values[0])]);
                $('#length_to').val(length[parseFloat(ui.values[1])]);
                $('#length_right_hidden').val(length[parseFloat(ui.values[1])]);
             
                //applied filter start
                 var isSelected = false;                
                 if(length[parseFloat(ui.values[0])] != parseFloat(default_length_min) || length[parseFloat(ui.values[1])] != parseFloat(default_length_max)){
                       isSelected = true;
                 }
                var filterValues = translations.titleLength+': '+length[parseFloat(ui.values[0])] +' - '+length[parseFloat(ui.values[1])];
                setSelectedFilter(filterValues,"length_slider_render('"+default_length_min+"', '"+default_length_max+"','true','"+filterLabel+"')",isSelected,'length');
                updateSessionFilters(session_variable+'-filters',translations.titleLength,length[parseFloat(ui.values[0])]+","+length[parseFloat(ui.values[1])]);

                if(resetFlag != 'true'){
                  jQuery('#page_no').val(1);
                  jQuery('#pagination').val('');    
                  graphqlDataCall();    
                }
      }
    }

  });

  var start_limit = parseFloat(min_length);
  var end_limit = parseFloat(max_length);

  $("#length_from").val(start_limit.toFixed(2));
  $("#length_to").val(end_limit.toFixed(2));

  $('#length_left_hidden').val(min_length);
  $('#length_right_hidden').val(max_length);
}

function replace_length_from(ele,min_length,filterLabel) {    
  if($('#length_from').val() == '') {
    var min_value = parseFloat($('#length_left_hidden').val());
    $('#length_from').val((min_value.toFixed(2)));
    return false;
  } else {
    var length_value = parseFloat($('#length_from').val());
    var hidden_length_value = $('#length_left_hidden').val();
  }
  
  var length_min_value = parseFloat($('#length_from').val());
  var length_max_value = parseFloat($('#length_to').val());
  
  if(isNaN(length_min_value) != false) {
    var value = parseFloat(default_length_min);
    alert(translations.titlePleaseEnterValueInNumber);
    $('#length_from').val(value);
        return false;
  } else if (length_min_value > length_max_value) {
    alert(translations.titleIncorrectLengthRange);
    var min_value = parseFloat($('#length_left_hidden').val());
    $('#length_from').val(min_value.toFixed(2));
    return false;
  } else if (length_value < default_length_min) {
    alert(translations.titleIncorrectLengthRange);
    $('#length_from').val(default_length_min);
    length_slider_render(default_length_min, length_max_value, true, filterLabel);
    return false;
  }

  $('#length_left_hidden').val(length_min_value);
  $('#length_right_hidden').val(length_max_value);

  length_slider_render(length_min_value, length_max_value, true, filterLabel);
}

function replace_length_to(ele,max_length,filterLabel) {
  if (jQuery('#length_to').val() == '') {
    var max_value = parseFloat(jQuery('#length_right_hidden').val());
    jQuery('#length_to').val(value.toFixed(2));
    return false;
  } else {
    var length_value = parseFloat(jQuery('#length_to').val());
    var hidden_length_value = $('#length_right_hidden').val();
  }
    
  var length_min_value = parseFloat($('#length_from').val());
    var length_max_value = parseFloat(jQuery('#length_to').val());
  
  if (isNaN(length_max_value) != false) {
    var max_value = default_length_max;
    alert(translations.titlePleaseEnterValueInNumber);
    jQuery('#length_to').val(max_value);
        return false;
  } else if (length_min_value > length_max_value) {
    alert(translations.titleIncorrectLengthRange);
    var max_value = parseFloat(jQuery('#length_right_hidden').val());
    jQuery('#length_to').val(max_value.toFixed(2));
    return false;
  } else if (length_max_value > default_length_max) {
    $('#length_to').val(default_length_max);
    length_slider_render(length_min_value, default_length_max, true, filterLabel);
    return false;
  }

  $('#length_right_hidden').val(length_max_value);
  $('#length_left_hidden').val(length_min_value);

  length_slider_render(length_min_value, length_max_value, true, filterLabel);
}
/*** End ***/

/*** Width Slider Filter Start ***/
function getWidthCalibArray(width_min,width_max) {  
  var width = [];
  for(i = parseFloat(width_min); i < parseFloat(width_max); i = i + 0.01){
    var dec = i.toFixed(2);
    width.push(dec);
  }  
  width.push(width_max);
  return width;
}

function width_slider_render(min_width, max_width, option, filterLabel) {
    var width = getWidthCalibArray(default_width_min,default_width_max);
  var minWidth = getClosestNum(min_width, width);
  var maxWidth = getClosestNum(max_width, width);
  var width_min = get_index(minWidth, width); 
  var width_max = get_index(maxWidth, width);

    //session depth filter selected
     var isSelected = false;
     if(parseFloat(min_width) != parseFloat(default_width_min) || parseFloat(max_width) != parseFloat(default_width_max)){
       isSelected = true;
     }

     var filterValues = filterLabel+': '+min_width+' - '+max_width;
     setSelectedFilter(filterValues,"width_slider_render('"+parseFloat(default_width_min)+"', '"+parseFloat(default_width_max)+"','true','"+filterLabel+"')",isSelected,'width');
     //end
  
  jQuery("#tps_width_slider").slider({
    range: true,
    min: 0,
    max: width.length - 1,
    values: [width_min, width_max],
    slide: function(event, ui) {
      emptyResultDiv();
          
      if ((ui.values[0] > ui.values[1])) {
        return false;
      }

      $("#width_from").val(width[parseFloat(ui.values[0])]);
      $('#width_left_hidden').val(width[parseFloat(ui.values[0])]);
      $('#width_to').val(width[parseFloat(ui.values[1])]);
      $('#width_right_hidden').val(width[parseFloat(ui.values[1])]);
    },
    change: function(event, ui) {
            var resetFlag = checkResetFlag();
      emptyResultDiv();
          
      if ((ui.values[0] > ui.values[1])) {
        return false;
      }
      
      if (option) {
                $("#width_from").val(width[parseFloat(ui.values[0])]);
                $('#width_left_hidden').val(width[parseFloat(ui.values[0])]);
                $('#width_to').val(width[parseFloat(ui.values[1])]);
                $('#width_right_hidden').val(width[parseFloat(ui.values[1])]);
             
                //applied filter start
                 var isSelected = false;                
                 if(width[parseFloat(ui.values[0])] != parseFloat(default_width_min) || width[parseFloat(ui.values[1])] != parseFloat(default_width_max)){
                       isSelected = true;
                 }
                var filterValues = translations.titleWidth+': '+width[parseFloat(ui.values[0])] +' - '+width[parseFloat(ui.values[1])];
                setSelectedFilter(filterValues,"width_slider_render('"+default_width_min+"', '"+default_width_max+"','true','"+filterLabel+"')",isSelected,'width');
                updateSessionFilters(session_variable+'-filters',translations.titleWidth,width[parseFloat(ui.values[0])]+","+width[parseFloat(ui.values[1])]);

                if(resetFlag != 'true'){
                  jQuery('#page_no').val(1);
                  jQuery('#pagination').val('');    
                  graphqlDataCall();    
                }
      }
    }

  });

  var start_limit = parseFloat(min_width);
  var end_limit = parseFloat(max_width);

  $("#width_from").val(start_limit.toFixed(2));
  $("#width_to").val(end_limit.toFixed(2));

  $('#width_left_hidden').val(min_width);
  $('#width_right_hidden').val(max_width);
}

function replace_width_from(ele,min_width,filterLabel) {    
  if($('#width_from').val() == '') {
    var min_value = parseFloat($('#width_left_hidden').val());
    $('#width_from').val((min_value.toFixed(2)));
    return false;
  } else {
    var width_value = parseFloat($('#width_from').val());
    var hidden_width_value = $('#width_left_hidden').val();
  }
  
  var width_min_value = parseFloat($('#width_from').val());
  var width_max_value = parseFloat($('#width_to').val());
  
  if(isNaN(width_min_value) != false) {
    var value = parseFloat(default_width_min);
    alert(translations.titlePleaseEnterValueInNumber);
    $('#width_from').val(value);
        return false;
  } else if (width_min_value > width_max_value) {
    alert(translations.titleIncorrectWidthRange);
    var min_value = parseFloat($('#width_left_hidden').val());
    $('#width_from').val(min_value.toFixed(2));
    return false;
  } else if (width_value < default_width_min) {
    alert(translations.titleIncorrectWidthRange);
    $('#width_from').val(default_width_min);
    width_slider_render(default_width_min, width_max_value, true, filterLabel);
    return false;
  }

  $('#width_left_hidden').val(width_min_value);
  $('#width_right_hidden').val(width_max_value);

  width_slider_render(width_min_value, width_max_value, true, filterLabel);
}

function replace_width_to(ele,max_width,filterLabel) {
  if (jQuery('#width_to').val() == '') {
    var max_value = parseFloat(jQuery('#width_right_hidden').val());
    jQuery('#width_to').val(value.toFixed(2));
    return false;
  } else {
    var width_value = parseFloat(jQuery('#width_to').val());
    var hidden_width_value = $('#width_right_hidden').val();
  }
    
  var width_min_value = parseFloat($('#width_from').val());
    var width_max_value = parseFloat(jQuery('#width_to').val());
  
  if (isNaN(width_max_value) != false) {
    var max_value = default_width_max;
    alert(translations.titlePleaseEnterValueInNumber);
    jQuery('#width_to').val(max_value);
        return false;
  } else if (width_min_value > width_max_value) {
    alert(translations.titleIncorrectWidthRange);
    var max_value = parseFloat(jQuery('#width_right_hidden').val());
    jQuery('#width_to').val(max_value.toFixed(2));
    return false;
  } else if (width_max_value > default_width_max) {
    $('#width_to').val(default_width_max);
    width_slider_render(width_min_value, default_width_max, true, filterLabel);
    return false;
  }

  $('#width_right_hidden').val(width_max_value);
  $('#width_left_hidden').val(width_min_value);

  width_slider_render(width_min_value, width_max_value, true, filterLabel);
}
/*** End ***/

/*** Get Slider Range Filter Min, Max Values ***/
function getFilterValues(min_value,max_value,filter) {
  var filterArray = getFilterArray(filter);

  var i=0;
  var selected_values = [];
  $.each(filterArray, function(key,cut){     
    if(store_lang == 'de'){
       if(i == min_value){
        selected_values.push(cut);
      }
      if(i == max_value-1){
        selected_values.push(cut);
      }
    }else{
      if(i == min_value){
        selected_values.push(key);
      }
      if(i == max_value-1){
        selected_values.push(key);
      }
    }
    i++;     
  });
  
  return selected_values;
}
/*** End ***/


/*** Get Selected Slider Range Filter Values ***/
function getSelectedRangeFilterValues(min_value,max_value,filter,default_value) {
  var filterArray = getFilterArray(filter);

  var i = 0;
  var selected_values = '';
  $.each(filterArray, function(key,cut){   
    if(min_value != 0 || max_value != default_value){
      if(i >= min_value && i <= max_value-1){
          if(i == max_value-1){
            selected_values += key;
          }else{
            selected_values += key+',';
          }        
        }
        i++;  
    }       
  });
  
  return selected_values;
}
/*** End ***/

/*** Get Filter Array Values ***/
function getFilterArray(filter) {
  var filterArray = '';
  if(filter == 'clarity'){
    filterArray = clarity_array;   
  }
  return filterArray;
}
/*** End ***/

/*** Set Selected Filters For Session Filters After Reloading Page start ***/
function setSelectedFilter(filter_value, func, hasSelectedClass, input_value = '') { 
  
  if (input_value == 'price') {
    $('.tps-selected-filter-container').find('li[data-input="price"]').remove();
  }else if (input_value == 'carat') {     
    $('.tps-selected-filter-container').find('li[data-input="carat"]').remove();
  }else if (input_value == 'clarity') {
    $('.tps-selected-filter-container').find('li[data-input="clarity"]').remove();
  }else if (input_value == 'length') {
    $('.tps-selected-filter-container').find('li[data-input="length"]').remove();
    }else if (input_value == 'width') {
    $('.tps-selected-filter-container').find('li[data-input="width"]').remove();
  }
  
  var value = filter_value.split(':');
    
   
  if (hasSelectedClass) {
    var html = '';
        var filter_lable = value[1].trim();
        if(input_value != 'price' && input_value != 'carat' && input_value != 'clarity' && input_value != 'length' && input_value != 'width') {
          //filter_lable = filter_lable.replace(/\-/g, ' ');
        }
    html += '<li onclick="' + func + '" data-input="' + input_value + '" data-filter_value="' + filter_value + '"><div class="tps-filter-values">' + filter_lable + '<span class="tps-filter-remove-option"></span></div></li>';
    if ($('#' + value[0] + '-container').length > 0) {
      $('#' + value[0] + '-container').append(html);
    } else {
      var elecontainer = '<ul id="' + value[0] + '-container"><span class="tps-applied-filter-lable">' + value[0] + ':</span></ul>';
      $('.tps-selected-filter-container').append(elecontainer);
      $('#' + value[0] + '-container').append(html);
    }    
  } else {
    $('.tps-selected-filter-container').find('li[data-filter_value="' + filter_value + '"]').remove();
    if ($('input[value="' + input_value + '"]').length > 0) {
      $('input[value="' + input_value + '"]').prop('checked', false);
    }

    if ($('#' + value[0] + '-container li').length == 0) {
      $('#' + value[0] + '-container').remove();
    }
  }
  if ($('.tps-selected-filter-container li').length > 0) {
    $('.tps-selected-filter-wrapper').show();
  } else {
    $('.tps-selected-filter-wrapper').hide();
  }
}
/*** set selected filters for session filters after reloading page end ***/

/*** Empty Diamond Result Div On Filter Click Start ***/
function emptyResultDiv(flag){
  var gemstone_active_tab = jQuery('#gemstone_active_tab').val();  
    
  jQuery('.tps-'+gemstone_active_tab+'-diamond-data .tps-gemstonelist-result-list-view-items-list').removeClass('tps-no-diamonds-found');
  jQuery('.tps-'+gemstone_active_tab+'-diamond-data .tps-gemstonelist-result-grid-view-items-list').removeClass('tps-no-diamonds-found');

  jQuery('.tps-'+gemstone_active_tab+'-diamond-data .tps-gemstonelist-result-list-view-items-list').html('');
  jQuery('.tps-'+gemstone_active_tab+'-diamond-data .tps-gemstonelist-result-grid-view-items-list').html('');

  getAllGemstones();
}
/*** End ***/

/*** Show Listing View Loader Start ***/
function showLoader(active_tab) {  
  jQuery('.tps-'+active_tab+'-diamond-data .tps-gemstonelist-result-list-view-loader').css('display','block');
  jQuery('.tps-'+active_tab+'-diamond-data .tps-gemstonelist-result-grid-view-loader').css('display','block');
}
/*** Show Listing View Loader End ***/

/*** Sort By Dropdown Open Close ***/
function sortByOpen() {
  if(jQuery('.tps-sort-dropdown-menu').css('display') !== 'none'){    
      sortByClose();
  }else {   
      jQuery('.tps-sort-dropdown-menu').css('display', 'block');

      if(jQuery(window).width() <= 824){
        jQuery('.tps-sort-dropdown-menu').addClass('tps-sort-dropdown-menu-show');
      }
  }
}
/*** End ***/

/*** Sort By Dropdown Close OnMouseLeave ***/
function sortByClose() {
  jQuery(".tps-sort-dropdown-menu").css('display', 'none');

  if(jQuery(window).width() <= 824){
    jQuery('.tps-sort-dropdown-menu').removeClass('tps-sort-dropdown-menu-show');
  }
}
/*** End ***/

/*** Sort Filter ***/ 
$(document).on("click", ".tps-sort-option", function() {
  sortByClose();
  emptyResultDiv();
  
  var sort_by = $(this).attr('data-sort');
  var sort_title = $(this).attr('data-title');
  var sort_type = $(this).attr('data-type');
  var sort_field_list = sort_by.replace('_', '-');
  
  jQuery('#sort_call').val(sort_by); 
  jQuery('#sort_dir').val(sort_type);

  if(sort_type=="asc"){
      sort_order = translations.titleSortLowToHigh;
      jQuery('.tps-sort-icon-'+sort_field_list).addClass('tps-arrow-down').removeClass('tps-arrow-up');
  }else{
      sort_order = translations.titleSortHightToLow;
      jQuery('.tps-sort-icon-'+sort_field_list).removeClass('tps-arrow-down').addClass('tps-arrow-up');
  }
  jQuery('.tps-sort-by-value').html('<span>'+sort_title+': '+sort_order+'</span>');
  
  jQuery('.tps-sort-option').removeClass('active');
  var sort_field_grid = sort_by+'_'+sort_type.toLowerCase();
  jQuery('.'+sort_field_grid).addClass('active');

  jQuery('#page_no').val(1);
  jQuery('#pagination').val('');
  
  graphqlDataCall();

  updateSessionFilters(session_variable+'-other-data','Sort-By',sort_by);
  updateSessionFilters(session_variable+'-other-data','Sort-Direction',sort_type);
});
/*** End ***/

/***Diamond List View Sort Filter Start ***/
function sorting_data(sorting, className) {
    emptyResultDiv();  
  var sortorder = '';

  // jQuery('.tps-sort-icon').each(function() {
  //  if (jQuery(this).hasClass('tps-arrow-up')) {
  //    jQuery(this).removeClass('tps-arrow-up').addClass('tps-arrow-down');
  //  }
  // });

  // if ((mySelection[1] == sorting) && (mySelection[2] == 'asc')) {
  //  sortorder = 'desc';
  //  jQuery(className).find('i').removeClass('tps-arrow-down').addClass('tps-arrow-up');
  // } else {
  //  sortorder = 'asc';
  //  jQuery(className).find('i').addClass('tps-arrow-down').removeClass('tps-arrow-up');
  // }

    jQuery(".tps-sort-icon").each(function() {
    jQuery(this).hasClass("tps-arrow-up") && jQuery(this).removeClass("tps-arrow-up").addClass("tps-arrow-down")
  }), mySelection[1] == sorting && mySelection[2] == "asc" || mySelection.length == 0 ? (sortorder = "desc", jQuery(className).find("i").removeClass("tps-arrow-down").addClass("tps-arrow-up")) : (sortorder = "asc", jQuery(className).find("i").addClass("tps-arrow-down").removeClass("tps-arrow-up"));

    //change grid view dropdown value    
    var sort_value = ''+sorting+'_'+sortorder;     
    var sort_text = jQuery('.'+sort_value).attr('value');
    jQuery('.tps-sort-by-value').text(sort_text);   

    jQuery('.tps-sort-option').removeClass('active');
    var sort_field_grid = sorting+'_'+sortorder;
    jQuery('.'+sort_field_grid).addClass('active');
  
  jQuery('#sort_call').val(sorting);
  jQuery('#sort_dir').val(sortorder);

  mySelection[1] = jQuery('#sort_call').val();
  mySelection[2] = jQuery('#sort_dir').val();
  jQuery('#page_no').val(1);
  jQuery('#pagination').val('');
  graphqlDataCall();

    updateSessionFilters(session_variable+'-other-data','Sort-By',sorting);
    updateSessionFilters(session_variable+'-other-data','Sort-Direction',sortorder);
}
/*** End ***/

/*** Sort By Popoup Close In Mobile On Outer Close Start ***/
jQuery(document).on('click','.tps-sort-dropdown-menu-show',function(e){
  var container = $(".tps-mobile-section");
    
  // If the target of the click isn't the container
  if(!container.is(e.target) && container.has(e.target).length === 0){        
    sortByClose();
  }
});
/*** Sort By Popoup Close In Mobile On Outer Close End ***/

/*** Graphql Call To Get Diamond Data ***/  
function graphqlDataCall(){
   jQuery('.diamond-grid-row').removeClass('tps-recent-viewed-gemstone');
   jQuery('.diamond-list-row').removeClass('tps-recent-viewed-gemstone');
   var gemstone_active_tab = jQuery('#gemstone_active_tab').val();
   showLoader(gemstone_active_tab); 
   jQuery(".tps-dia-count").html("(<span class='tps-dia-count-loader'></span>)"); //display diamond count loader before Gemstones load
   jQuery(".tps-recent-diamonds-tab").addClass("tps-tab-disabled");
   jQuery(".tps-compare-diamonds-tab").addClass("tps-tab-disabled");
  
  var page_no = jQuery('#page_no').val(); 
  // var gemstone_type = ''; 
  var gem_shape = jQuery('#gem_shape').val();
  var gem_color = jQuery('#gem_fancy_color').val();
  var gem_origin = jQuery('#gem_origin').val(); 
  var gem_report = jQuery('#gem_report').val(); 
  var gem_type = jQuery('#gem_type').val(); 
  var gem_treatment = jQuery('#gem_treatment').val(); 
  var carat_min = jQuery("#carat_left_hidden").val();
  var carat_max = jQuery("#carat_right_hidden").val();
  var price_min = jQuery("#price_left_hidden").val();
  var price_max = jQuery("#price_right_hidden").val();
  var clarity_min = jQuery('#clarity_min_value').val();
  var clarity_max = jQuery('#clarity_max_value').val();  
  var length_min = jQuery("#length_left_hidden").val();
  var length_max = jQuery("#length_right_hidden").val();
  var sort_call = jQuery('#sort_call').val(); 
  var sort_dir = jQuery('#sort_dir').val();
  var bulk_page_data = getBulkPageDataValuesFromSession(); 
  if(jQuery(window).width() > 900 && jQuery(window).width() < 1198){
    var gemstones_display_per_page = 39; 
  }else{
    var gemstones_display_per_page = 40; 
  }

  //get values of diamond clarity selected filters in english 
  var gem_clarity = getSelectedRangeFilterValues(clarity_min,clarity_max,'clarity',default_max_clarity);   
  //end

  //Rest Of Africa replace Rest_Of_Africa and United States replace UnitedStates origin filter
  if(gem_origin != ''){
    var origin_filter = gem_origin.split(',');
    var origin_array = [];
    $.each(origin_filter, function(i, origin) {
      var formatted_origin = origin.replace(/ /g,"_");
      origin_array.push(formatted_origin);
    });
    gem_origin = origin_array.join(",");
  }
  //end
  
  //query parameters for graphql call
  var postdata = JSON.stringify({ query:`{
                  ${gemstoneListingApi}(page: "` +
              page_no +
              `", pageSize:"`+gemstones_display_per_page+`", shapes:"` +
              gem_shape +
              `", color:"`+ gem_color +`", carat:"` +
              carat_min +
              `, ` +
              carat_max +
              `", clarity:"` +
              gem_clarity +
              `", treatment:"`+gem_treatment+`", price:"` +
              price_min +
              `, ` +
              price_max +
              `",lab:"`+gem_report+`", gemstoneType:"`+gem_type+`",origin:"`+gem_origin+`",length:"`+length_min+`,`+length_max+`",bulkPageData:"`+bulk_page_data+`", orderBy:"`+sort_call+`", sortBy:"` +
              sort_dir +
              `", currencyFlag:"")
                  {
                   dataCount
                   gemstonesReturned
                   pageNo
                   gemstone{
                   gemstoneId                     
                    shape 
                    caratWeight  
                    color 
                    fancyColor 
                    fancyColorIntensity
                    fancyColorOvertone 
                    clarity 
                    cut 
                    symmetry 
                    polish 
                    deptPerc 
                    tablePerc 
                    length 
                    width 
                    depth 
                    ratio 
                    measurement 
                    girdle
                    girdleMin 
                    girdleMax 
                    girdleCondition 
                    culet 
                    culetCondition  
                    flourIntensity  
                    certificateFile 
                    lab                      
                    finalPrice     
                    certificateNumber 
                    stockNumber 
                    gemstoneImage  
                    gemstoneVideo  
                    gemstoneType 
                    currencyCode 
                    currencySymbol
                    treatment
                    measurement
                    length
                    width
                   }
                  }
                  }
                  `});            
    abortAjax(xhr);
      
    //ajax graphql call for diamonds
    xhr = jQuery.ajax({
      url:api,
      contentType: "application/json",
      type:'POST',
      data: postdata,
      success: function(response) {    
        var gem_data = response.data[gemstoneListingApi].gemstone;  
        
        var gem_count;
        if(response.data[gemstoneListingApi].dataCount == null){
          var gem_count = 0;
          var gem_return = 0;
        }else{
          var gem_count = response.data[gemstoneListingApi].dataCount;
          var gem_return = response.data[gemstoneListingApi].gemstonesReturned;
        }

        getGemstoneListView(gem_data,gem_count,gem_return,bulk_page_data,gemstones_display_per_page);          
        
        //diamond info focus return from diamond detail page  
        var session_variable = jQuery("#session_variable").val();
        var session_other_data = JSON.parse(localStorage.getItem(session_variable+'-other-data'));
        if(session_other_data != '' && session_other_data != null){
          if(session_other_data['Single-Recent-Gemstone'] != null && session_other_data['Single-Recent-Gemstone'] != '' && session_other_data['Single-Recent-Gemstone'] != undefined){
            var recentGemstone = session_other_data['Single-Recent-Gemstone'][0];
            var ViewType = session_other_data['View-Type'][0];
            focusRecentGemstone(recentGemstone,ViewType);            
          }     
        }
        //end       
      }
    });      

}
/*** End ***/

/*** Check Bulk Page Data Flag For Back TO Serach Gemstones start ***/
function getBulkPageDataValuesFromSession() {
  var bulk_page_data = 'no';
  var session_other_data = JSON.parse(localStorage.getItem(session_variable+'-other-data'));
  if(session_other_data != '' && session_other_data != null){
    if(session_other_data['Recent-Gemstone-Page-No'] != undefined && session_other_data['Recent-Gemstone-Page-No'][0] != ''){      
      var bulk_page_data = 'yes';
    }
  }
  return bulk_page_data;
}
/*** Check Bulk Page Data Flag For Back TO Serach Gemstones End ***/

/*** Abort XHR Start ***/
function abortAjax(xhr) {
  if(xhr && xhr.readystate != 4){
    xhr.abort();
  }
}
/*** End ***/

/*** Focus Recently View Diamond Start ***/
function focusRecentGemstone(gemstone_id,view_type) {
  if(view_type == 'list'){
     var target = '.diamond-list-item-'+gemstone_id;
     openCloseDetailInfo(gemstone_id,'all','list','open',target); 
  }else{
    var target = '.diamond-grid-item-'+gemstone_id; 
  }
  
  $(target).addClass('tps-recent-viewed-gemstone');
  $('html, body').animate({
        scrollTop: $(target).offset().top - 300
  }, 'slow'); 
  
  updateSessionFilters(session_variable+'-other-data','Single-Recent-Gemstone', '');
  updateSessionFilters(session_variable+'-other-data','Recent-Gemstone-Page-No', '');
  setTimeout(function(){ $(target).removeClass('tps-recent-viewed-gemstone'); }, 1000);
}
/*** End ***/

/*** Gemstones Layout Start ***/
function getGemstoneListView(allGemstoneData,gem_count,gem_return,bulk_page_data,gemstones_display_per_page){  
  var active_tab = jQuery('#gemstone_active_tab').val();
  var page_no = jQuery('#page_no').val(); 
  var pagination = jQuery("#pagination").val();
  
  jQuery(".tps-dia-count").text("("+addCommas(gem_count)+")");
  jQuery(".tps-total-diamonds").text(addCommas(gem_count));
  jQuery("#total_product").val(gem_count);
  jQuery(".tps-load-more-button-section").show();
  jQuery(".tps-recent-diamonds-tab").removeClass("tps-tab-disabled");
  jQuery(".tps-compare-diamonds-tab").removeClass("tps-tab-disabled");
    
  var compare_gemstone = [];      
  if(session_other_data != '' && session_other_data != null){
    if(session_other_data['Compare-Gemstones'] != undefined && session_other_data['Compare-Gemstones'] != null){
      if(session_other_data['Compare-Gemstones'] != null && session_other_data['Compare-Gemstones'] != ''){
        var compare_gemstone = session_other_data['Compare-Gemstones'];
      }
    }
  }
    
  //Diamond List View
  var gemListView = '';
  var gemGridView = '';

  var tableHeadWidthlist = Math.round(100/9);
  jQuery('.table-head').css('width', tableHeadWidthlist + '%');
  
  if(allGemstoneData != '' && allGemstoneData != null){     
    $.each(allGemstoneData, function(i, gemstoneData) { 
       gemListView += getGemstoneListingViewLayout(gemstoneData,compare_gemstone,active_tab);
       gemGridView += getGemstoneListingGridLayout(gemstoneData,compare_gemstone,active_tab,i);
    });    
  }else{
    jQuery(".tps-load-more-button-section").hide();
    
    gemListView += '<span class="tps-no-diamond-found">'+translations.titleNoGemstoneFound+'</span>';
    gemGridView += '<span class="tps-no-diamond-found">'+translations.titleNoGemstoneFound+'</span>';

    jQuery('.tps-'+active_tab+'-diamond-data .tps-gemstonelist-result-list-view-items-list').addClass('tps-no-diamonds-found');
    jQuery('.tps-'+active_tab+'-diamond-data .tps-gemstonelist-result-grid-view-items-list').addClass('tps-no-diamonds-found');
  }

  if(page_no == 1){
    jQuery('.tps-'+active_tab+'-diamond-data .tps-gemstonelist-result-list-view-items-list').html(gemListView);
    jQuery('.tps-'+active_tab+'-diamond-data .tps-gemstonelist-result-grid-view-items-list').html(gemGridView);    
  }else{
    jQuery('.tps-'+active_tab+'-diamond-data .tps-gemstonelist-result-list-view-items-list').append(gemListView);
    jQuery('.tps-'+active_tab+'-diamond-data .tps-gemstonelist-result-grid-view-items-list').append(gemGridView);
  }
  
  jQuery('.tps-'+active_tab+'-diamond-data .tps-gemstonelist-result-list-view-loader').hide();
  jQuery('.tps-'+active_tab+'-diamond-data .tps-gemstonelist-result-grid-view-loader').hide();
  //End  

  var pageid = parseInt(page_no)+1;  
  jQuery('#page_no').val(pageid);
  
  //Load More Button Hide Show 
  if(gem_return == undefined){ 
    jQuery(".tps-load-more").hide();
  }else if(gem_return < gemstones_display_per_page || gem_count == gemstones_display_per_page){
    var previous_page_no = parseInt(page_no)-1;
    var total_previous_gemstones = previous_page_no*gemstones_display_per_page;
    var gemstone_viewed = parseInt(total_previous_gemstones)+parseInt(gem_return);
    
    jQuery('.tps-total-diamonds-displays').html(addCommas(gemstone_viewed));
    jQuery(".tps-load-more").hide();
  }else{        
    if(bulk_page_data == 'yes'){      
      var gemstone_viewed = gem_return;
    }else{
      var gemstone_viewed = page_no*gemstones_display_per_page;
    }    
    jQuery('.tps-total-diamonds-displays').html(addCommas(gemstone_viewed));
    jQuery(".tps-load-more").show();
  }  
  //end.
  
  // scrollFlag = 0; 
}
/*** End ***/

/*** Gemstones Listing Grid Layout Start ***/
function getGemstoneListingGridLayout(gemstoneData,compare_gemstone,active_tab,gemstoneIndex) {
  var page_no = jQuery('#page_no').val(); 
  var banner_display_count = jQuery('#tps_banner_row_count').val();
  var gemstone_index = gemstoneIndex+1;  
  var currency_rate = Shopify.currency.rate;
  var gemstone_id = gemstoneData.gemstoneId;
  var gemstone_shape = gemstoneData.shape;
  var gemstone_type = gemstoneData.gemstoneType;   
  var gemstone_title = getGemstoneName(gemstoneData,gemstone_type);   
  var gemstone_certificate_url = getCertificateUrl(gemstoneData); 
  var final_price = gemstoneData.finalPrice;   
  var gemstone_price = getGemstonePrice(currency_rate,final_price);   

   var dia_img = gemstoneData.gemstoneImage; 
  var diamondStockImage = [];

   if(dia_img == 'None' ){
     //get diamond stock image url
     $.each(gemstoneImageUrl, function(i, gemstoneImage) {   
        var imageParam = 'gemstone_sample_image';
       
        if(gemstoneImage.includes(imageParam)){    
          diamondStockImage.push(gemstoneImage);
        }
      });
  }

    var wishlistProducts = jQuery("#wishlist_products").val();
  wishlistProducts = wishlistProducts.split(",");
  
  var compareClass = '';
  if($.inArray(gemstoneData.gemstoneId.toString(), compare_gemstone)!=(-1)){
    var compareClass = 'active';            
  }

  diaGrid = '';
  if(active_tab == 'compare'){
    diaGrid += '<li class="tps-gemstonelist-result-grid-view-item diamond-grid-row diamond-grid-item-'+gemstoneData.gemstoneId+'" data-id="'+gemstoneData.gemstoneId+'" data-page="'+page_no+'" data-compare-id="' + gemstone_id + '">';
  }else{
    diaGrid += '<li class="tps-gemstonelist-result-grid-view-item diamond-grid-row diamond-grid-item-'+gemstoneData.gemstoneId+'" data-id="'+gemstoneData.gemstoneId+'" data-page="'+page_no+'">';
  }
  if(gemstoneData.gemstoneType == 'lab'){
    diaGrid += '<div class="tps-gemstonelist-item-badget-span">';
    diaGrid += '<div class="tps-gemstonelist-item-badget-span-list">';
    diaGrid += '<div class="tps-gemstonelist-result-badget-info tps-gemstonelist-result-badget-info-lab">'+translations.titleLab+'</div>';
    if(gemstoneData.process != '' && gemstoneData.process != null){
      diaGrid += '<div class="tps-gemstonelist-result-badget-info tps-gemstonelist-result-badget-treatment">'+gemstoneData.process+'</div>';
    }
    diaGrid += '</div>';
    diaGrid += '</div>';
  }
  diaGrid += '<div class="tps-gemstonelist-item-info-span">';
  diaGrid += '<div class="tps-gemstonelist-item-info-span-list">';
  diaGrid += '<div class="tps-gemstonelist-result-grid-info">';
  diaGrid += '<span class="tps-gemstonelist-result-grid-info-span tps-gemstone-info-span" title="'+translations.titleMoreInformation+'" data-id="'+gemstoneData.gemstoneId+'" onclick="openCloseDetailInfo(`'+gemstone_id+'`,`'+active_tab+'`,`grid`,`open`,event);">info</span>';
  diaGrid += '</div>';
  if(active_tab == 'all'){
    diaGrid += '<div class="tps-gemstonelist-result-grid-compare diamond-compare-'+gemstoneData.gemstoneId+' '+compareClass+'">';
    diaGrid += '<input type="checkbox" class="tps-gemstonelist-compare-chk diamond-checkbox-'+gemstoneData.gemstoneId+'" title="'+translations.titleCompareGemstone+'" onclick="event.stopPropagation();compareGemstones(`'+gemstone_id+'`);" data-diamond-id="'+gemstone_id+'" data-gemstone-name="'+gemstone_title+'" data-result-list-view-type="grid"><span class="tps-gemstonelist-compare-span"></span>';
    diaGrid += '</div>';
  }else if(active_tab == 'compare'){
    diaGrid += '<div class="tps-gemstonelist-result-grid-compare diamond-compare-'+gemstoneData.gemstoneId+' active">';
    diaGrid += '<input type="checkbox" class="tps-gemstonelist-compare-chk diamond-checkbox-'+gemstoneData.gemstoneId+'" title="'+translations.titleRemoveCompareGemstone+'" onclick="event.stopPropagation();removeCompare(`'+gemstone_id+'`);" data-diamond-id="'+gemstone_id+'" data-gemstone-name="'+gemstone_title+'" data-result-list-view-type="grid"><span class="tps-gemstonelist-compare-span"></span>';
    diaGrid += '</div>';
  }

  // if(dia_img != 'None'){
  //   diaGrid += '<div class="tps-productlist-wishlist tps-product-wishlist-'+gemstone_id+'" data-img="'+dia_img+'" data-id="'+gemstone_id+'" onclick="createDiamondProduct(this,`'+gemstone_type+'`);">';
  // }else{
  //   diaGrid += '<div class="tps-productlist-wishlist tps-product-wishlist-'+gemstone_id+'" data-img="'+diamondStockImage[0]+'" data-id="'+gemstone_id+'" onclick="createDiamondProduct(this,`'+gemstone_type+'`);">';
  // }
  // diaGrid += '<button class="love-button" gropulse-lbw-product-id="'+gemstone_id+'">';
  // diaGrid += '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="#13177a" class="bi bi-heart" viewBox="0 0 16 16" id="IconChangeColor">';
  // if(jQuery.inArray(gemstone_id.toString(),wishlistProducts)==(-1)){
  //   diaGrid += '<path d="m8 2.748-.717-.737C5.6.281 2.514.878 1.4 3.053c-.523 1.023-.641 2.5.314 4.385.920 1.815 2.834 3.989 6.286 6.357 3.452-2.368 5.365-4.542 6.286-6.357.955-1.886.838-3.362.314-4.385C13.486.878 10.4.28 8.717 2.01L8 2.748zM8 15C-7.333 4.868 3.279-3.04 7.824 1.143c.06.055.119.112.176.171a3.12 3.12 0 0 1 .176-.17C12.72-3.042 23.333 4.867 8 15z" id="mainIconPathAttribute" stroke-width="0.3" stroke="#13177a" fill="#13177a"></path>';
  // }else{
  //   diaGrid += '<path d="M8 1.314C12.438-3.248 23.534 4.735 8 15-7.534 4.736 3.562-3.248 8 1.314z" id="mainIconPathAttribute" stroke-width="0.3" stroke="#13177a" fill="#13177a"></path>';
  // }
  // diaGrid += '</svg></button>';  
  // diaGrid += '</div>';
  
  diaGrid += '</div>';
  diaGrid += '</div>';

   if(gemstoneData.gemstoneVideo != 'None' && gemstoneData.gemstoneVideo != ''){
    diaGrid += '<div class="tps-gemstonelist-item-360-video-icon-span">';
    if (jQuery(window).width() < 1199) { 
      diaGrid += '<span class="tps-gemstonelist-item-video-icon" onClick="event.stopPropagation();show360VideoMobile(`'+gemstoneData.gemstoneId+'`)">video</span>';
    }else{
      diaGrid += '<span class="tps-gemstonelist-item-video-icon">video</span>';
    }
    diaGrid += '</div>';
  }
  
  diaGrid += '<a href="'+tps_config.urls.loose_gemstone_detail+'?gemstone_id='+gemstoneData.gemstoneId+'&gemstone_type='+gemstoneData.gemstoneType+'" data-id="'+gemstoneData.gemstoneId+'" data-page="'+page_no+'">';
  diaGrid += '<div class="tps-gemstonelist-item-media-div">';
  diaGrid += getGemstoneImageLayout(gemstoneData,gemstone_title);
  if(gemstoneData.gemstoneVideo != 'None' && gemstoneData.gemstoneVideo != ''){
    diaGrid += '<span class="tps-gemstonelist-media-loader" style="display: none;"></span>';
    // diaGrid += '<span class="tps-gemstonelist-item-video-icon">video</span>';
    diaGrid += '<div class="tps-gemstonelist-video-iframe-div tps-embed-media-container" style="opacity: 0;">';
    diaGrid += '</div>';
  }
  diaGrid += '</div>';
  diaGrid += '<div class="tps-gemstonelist-result-grid-view-cn">'; 
  diaGrid += '<div class="tps-gemstonelist-item-title">'+gemstone_title+'</div>';
  diaGrid += '<div class="tps-gemstonelist-item-meta-data">'; 
  diaGrid += getGemstoneMetaInformation(gemstoneData);
  diaGrid += '</div>';          
  diaGrid += '<div class="tps-gemstonelist-item-price">'+gemstone_price+'</div>';          
  diaGrid += '</div>';
  diaGrid += '</a>';

  //diamond info layout start
   diaGrid += '<div class="tps-gemstonelist-item-info tps-gemstone-info-'+gemstoneData.gemstoneId+'" style="display:none;">';
   diaGrid += '<span class="tps-gemstonelist-item-info-close tps-gemstone-info-close" data-id="'+gemstoneData.gemstoneId+'" onclick="openCloseDetailInfo(`'+gemstone_id+'`,`'+active_tab+'`,`grid`,`close`,event);">close</span>';
   diaGrid += getGemstoneInformationLayout(gemstoneData);
   diaGrid += '</div>';
  //end
  diaGrid += '<input type="hidden" id="tps_gemstone_video_'+gemstoneData.gemstoneId+'" value="'+gemstoneData.gemstoneVideo+'">';
  diaGrid += '</li>';

  //banner start
  if(jQuery(window).width() > 900 && jQuery(window).width() < 1198){    
    banner_display_count = parseInt(banner_display_count)+1; //for tab view display banner after 21 gemstones
  }
  if(gemstone_index == banner_display_count){
    var bannerHtml = $('#tps_banner_blog_'+page_no).html();
    if(bannerHtml != '' && bannerHtml != undefined){
      diaGrid += '<li class="tps-gemstonelist-banner-section">';
      diaGrid += '<div class="tps-gemstone-listing-page-banner">'+bannerHtml+'</div>';
      diaGrid += '</li>';
    }
  }
  //banner end
  
  return diaGrid;
}
/*** End ***/

/*** Gemstones List View Layout Start ***/
function getGemstoneListingViewLayout(gemstoneData,compare_gemstone,active_tab) {
  var page_no = jQuery('#page_no').val(); 
  var currency_rate = Shopify.currency.rate;
  var gemstone_id = gemstoneData.gemstoneId;
  var gemstone_shape = gemstoneData.shape;
  var gemstone_type = gemstoneData.gemstoneType;   
  var gemstone_title = getGemstoneName(gemstoneData,gemstone_type);   
  var gemstone_certificate_url = getCertificateUrl(gemstoneData); 
  var final_price = gemstoneData.finalPrice;   
  var gemstone_price = getGemstonePrice(currency_rate,final_price);  
  
  if($.inArray(gemstoneData.gemstoneId.toString(), compare_gemstone)!=(-1)){
    var iconChk = 'checked';            
  }else{
    var iconChk = '';
  }
  
  var diaList = '';
  var tableHeadWidth = Math.round(100/9);
  
  if(active_tab == 'compare'){
    diaList += '<li class="tps-gemstonelist-result-list-view-item diamond-list-row diamond-list-item-'+gemstone_id+'" data-compare-id="'+gemstone_id+'">';
  }else{
    diaList += '<li class="tps-gemstonelist-result-list-view-item diamond-list-row diamond-list-item-'+gemstone_id+'">';
  }
  
  diaList += '<div class="tps-desktop-table-row" onclick="openCloseDetailInfo(`'+gemstone_id+'`,`'+active_tab+'`,`list`,`open`,event);">';  

  if(active_tab == 'all'){
    diaList += '<span class="table-data table-data-compare" style="width:'+tableHeadWidth+'%">';  
    diaList += '<i class="tps_checkbox"><input type="checkbox" value="'+gemstoneData.gemstoneId+'" data-product-id="'+gemstoneData.gemstoneId+'" data-role="none" class="diamond-checkbox-'+gemstoneData.gemstoneId+' grid_checkbox" name="idcompare'+gemstoneData.gemstoneId+'" data-gemstone-name="'+gemstone_title+'" value="'+gemstoneData.gemstoneId+'"  onclick="event.stopPropagation();compareGemstones(`'+gemstone_id+'`);" '+iconChk+'><span class="tps-gemstonelist-compare-span"></span></i>';       
    diaList += '</span>';
  }else if(active_tab == 'compare'){
    diaList += '<span class="table-data table-data-compare" onclick="event.stopPropagation();removeCompare(`'+gemstoneData.gemstoneId+'`);" style="width:'+tableHeadWidth+'%"><a href="javascript:void(0)" onclick="event.stopPropagation();removeCompare(`'+gemstoneData.gemstoneId+'`);">X</a></span>';
  }
  diaList += '<span class="table-data table-data-shape-image" style="width:'+tableHeadWidth+'%"><span class="tps-shape-icon tps-shape-icon-'+gemstone_shape.toLowerCase()+'"></span></span>';
  diaList += '<span class="table-data table-data-shape" style="width:'+tableHeadWidth+'%">'+gemstone_shape+'</span>';
  diaList += '<span class="table-data table-data-carat" style="width:'+tableHeadWidth+'%">'+gemstoneData.caratWeight+'</span>';
  if(gemstoneData.color != ''){
    diaList += '<span class="table-data table-data-color" style="width:'+tableHeadWidth+'%">'+gemstoneData.color+'</span>';
  }else{
    diaList += '<span class="table-data table-data-color" style="width:'+tableHeadWidth+'%">'+gemstoneData.fancyColor+'</span>';
  }
  diaList += '<span class="table-data table-data-clarity" style="width:'+tableHeadWidth+'%">'+gemstoneData.clarity+'</span>';
  diaList += '<span class="table-data table-data-report" style="width:'+tableHeadWidth+'%">'+gemstoneData.lab+'</span>';          
  diaList += '<span class="table-data table-data-price" style="width:'+tableHeadWidth+'%">'+gemstone_price+'</span>';
  diaList += '<span class="table-data table-data-view tps-gemstonelist-view-'+gemstoneData.gemstoneId+' tps-arrow-down" style="width:'+tableHeadWidth+'%"></span>';  
  diaList += '</div>';
  
  diaList += '<div class="tps-gemstonelist-detail-info tps-gemstone-detail-info-'+gemstoneData.gemstoneId+'" style="display:none;">';
  diaList += '<span class="tps-gemstonelist-detail-view-close" data-id="'+gemstoneData.gemstoneId+'" onclick="openCloseDetailInfo(`'+gemstone_id+'`,`'+active_tab+'`,`list`,`close`,event);">close</span>';
  diaList += '<div class="tps-gemstonelist-item-quick-view-wrapper">';  
  diaList += '<div class="tps-gemstonelist-detail-view-media">';
  diaList += getGemstoneImageLayout(gemstoneData,gemstone_title);  
  diaList += '</div>';

  //diamond info layout start
  diaList += '<div class="tps-gemstonelist-detail-view-info-table">';
  diaList += '<div class="tps-gemstonelist-detail-view-title">'+gemstone_title+'</div>';
  diaList += '<div class="tps-gemstonelist-detail-view-price">'+gemstone_price+'</div>';
  diaList += '<div class="tps-gemstonelist-detail-table-info">';
  diaList += getGemstoneInformationLayout(gemstoneData);
  diaList += '</div>';
  diaList += '</div>';
  //end
  
  diaList += '<div class="tps-gemstonelist-detail-view-btn-row">';
  diaList += '<a href="'+tps_config.urls.loose_gemstone_detail+'?gemstone_id='+gemstoneData.gemstoneId+'&gemstone_type='+gemstoneData.gemstoneType+'" class="tps-gemstonelist-detail-view-btn" data-id="'+gemstoneData.gemstoneId+'" data-page="'+page_no+'">'+translations.titleViewGemstone+'</a>';
  diaList += '</div>';
  
  diaList += '</div>';
  diaList += '</div>';
  
  diaList += '</li>';
  
  return diaList;
}
/*** End ***/

/*** 360 Video display in Mobile Start ***/
function show360VideoMobile(diamond_id) {  
  jQuery('.diamond-grid-item-'+diamond_id+' .tps-gemstonelist-media-loader').show();
  jQuery(".tps-embed-media-container").html("");
  var diamondItemDiv = jQuery(".diamond-grid-item-"+diamond_id);  
  
  var diamondID = diamond_id; 
  var diamondVideo = jQuery("#tps_gemstone_video_"+diamondID).val();    
  if (diamondVideo != '' && diamondVideo != 'None') {
    if (diamondVideo.indexOf("https://loupe360.com/diamond/") > -1){              
      diamondVideo = diamondVideo.replace('/500/500', '/resp/true/autoplay');
    }  
    
     var iframeVideoHTML = `<embed class="tps-gemstonelist-video-iframe tps-gemstonelist-video-iframe-`+diamondID+`" src="${diamondVideo}" type="text/html" width="${diamondItemDiv.outerWidth()}" height="${diamondItemDiv.outerHeight()}"><div class="tps-video-click-overlay"></div>`;
     jQuery('.diamond-grid-item-'+diamond_id+' .tps-gemstonelist-video-iframe-div').html(iframeVideoHTML);

     jQuery('.diamond-grid-item-'+diamond_id+' .tps-gemstonelist-detail-img').css('opacity', 0);
     jQuery('.diamond-grid-item-'+diamond_id+' .tps-gemstonelist-video-iframe-div').css('opacity', 1); 
     
     jQuery('.diamond-grid-item-'+diamond_id+' .tps-gemstonelist-video-iframe').bind('load', function(e) {
       jQuery('.diamond-grid-item-'+diamond_id+' .tps-gemstonelist-media-loader').hide();
     });
  }
}
/*** 360 Video display in Mobile End ***/

/*** Grid View On Image Hover 360 Video Display Start ***/ 
jQuery(document).on({
    mouseenter : function(e) {
        if (jQuery(window).width() > 1100) {
            var gemstoneItemDiv  = jQuery(this);
            var gemstoneId      = jQuery(this).attr("data-id");  
            
            if (gemstoneItemDiv.find('.tps-gemstonelist-video-iframe').length < 1) {
                var gemstoneVideo = jQuery("#tps_gemstone_video_"+gemstoneId).val();    
                if (gemstoneVideo != '' && gemstoneVideo != 'None') {
                    if (gemstoneVideo.indexOf("https://loupe360.com/diamond/") > -1){              
                      gemstoneVideo = gemstoneVideo.replace('/500/500', '/resp/true/autoplay');
                    }  
                    displayGemstoneVideo(gemstoneItemDiv, gemstoneVideo);
                }
            } else if(gemstoneItemDiv.find('.tps-gemstonelist-video-iframe').hasClass('video-loaded')) {
                switchGemstoneImageAndVideo(gemstoneItemDiv, 'video');
            } 
        }
    },
}, '.tps-gemstonelist-result-grid-view-item');
/*** Grid View On Image Hover 360 Video Display End ***/

/*** Grid View On Video Hover Out Image Display Start ***/ 
jQuery(document).on({
    mouseleave : function(e) {
        var gemstoneItemDiv  = jQuery(this);
        switchGemstoneImageAndVideo(gemstoneItemDiv, 'image');
    },
}, '.tps-gemstonelist-result-grid-view-item');
/*** Grid View On Video Hover Out Image Display End ***/ 

/*** Display Diamond 360 Video Start ***/
function displayGemstoneVideo(gemstoneItemDiv, gemstoneVideoURL = '') {     
   // var iframeVideoHTML = `<iframe src="${gemstoneVideoURL}" class="tps-gemstonelist-video-iframe" width="${gemstoneItemDiv.outerWidth()}" height="${gemstoneItemDiv.outerHeight()}" />`;
     var iframeVideoHTML = `<embed class="tps-diamondlist-video-iframe" src="${gemstoneVideoURL}" type="text/html" width="${gemstoneItemDiv.outerWidth()}" height="${gemstoneItemDiv.outerHeight()}"><div class="tps-video-click-overlay"></div>`;
  
    gemstoneItemDiv.find('.tps-gemstonelist-media-loader').show();
    gemstoneItemDiv.find('.tps-gemstonelist-video-iframe-div').prepend(iframeVideoHTML);
    gemstoneItemDiv.find('.tps-gemstonelist-video-iframe').bind('load', function(e) {
        if(!gemstoneItemDiv.find('.tps-gemstonelist-video-iframe').hasClass('focus-moved')){
            var currentIframe = jQuery(e.target);
            var mediaDiv    = currentIframe.parents('.tps-gemstonelist-item-media-div');      
            mediaDiv.find('.tps-gemstonelist-media-loader').hide();
            mediaDiv.find('.tps-gemstonelist-detail-img').css('opacity', 0);
            mediaDiv.find('.tps-gemstonelist-video-iframe-div').css('opacity', 1);  
        } 
        gemstoneItemDiv.find('.tps-gemstonelist-video-iframe').addClass('video-loaded');
    });
}
/*** Display Diamond 360 Video End ***/

/*** Switch Diamond Image And Video Start ***/
function switchGemstoneImageAndVideo(gemstoneItemDiv, divType = 'image') {    
    if(divType == 'video') {  
        gemstoneItemDiv.find('.tps-gemstonelist-video-iframe-div').css('opacity', 1);
        gemstoneItemDiv.find('.tps-gemstonelist-detail-img').css('opacity', 0);
        gemstoneItemDiv.find('.tps-gemstonelist-video-iframe').removeClass('focus-moved');
    } else {        
        jQuery('.tps-gemstonelist-media-loader').hide();
        jQuery('.tps-gemstonelist-video-iframe-div').css('opacity', 0);
        jQuery('.tps-gemstonelist-detail-img').css('opacity', 1);
        gemstoneItemDiv.find('.tps-gemstonelist-video-iframe').addClass('focus-moved');
    }   
}
/*** Switch Diamond Image And Video End ***/

/*** Gemstones Meta Information Layout Start ***/
function getGemstoneMetaInformation(gemstoneData) {
  var metaInfo = '';
  if(gemstoneData.color != ''){
    metaInfo += '<span class="tps-meta-data-item">'+gemstoneData.color+',</span>';
  }else{
    metaInfo += '<span class="tps-meta-data-item">'+gemstoneData.fancyColor+',</span>';
  }    
  if(gemstoneData.clarity != '' && gemstoneData.clarity != 'NA'){
    metaInfo += '<span class="tps-meta-data-item">'+gemstoneData.clarity+',</span>';
  }
  if(gemstoneData.cut != '' && gemstoneData.cut != 'NA'){
    metaInfo += '<span class="tps-meta-data-item">'+gemstoneData.cut+',</span>';
  }     
  if(gemstoneData.treatment != '' && gemstoneData.treatment != 'NA'){
    metaInfo += '<span class="tps-meta-data-item">'+gemstoneData.treatment+'</span>';
  }  
  // if(gemstoneData.symmetry != '' && gemstoneData.symmetry != 'NA'){
  //   metaInfo += '<span class="tps-meta-data-item">'+gemstoneData.symmetry+'</span>';
  // }  
  return metaInfo;
}
/*** End ***/

/*** Gemstones Image Layout Start ***/
function getGemstoneImageLayout(gemstoneData,gemstone_title) { 
  var session_variable = jQuery('#session_variable').val();
  var diamond_image = gemstoneData.gemstoneImage;
  var image = '';
  var diamondStockImage = [];

  //get diamond stock image url
  $.each(gemstoneImageUrl, function(i, gemstoneImage) {   
    var imageParam = 'gemstone_sample_image';
   
    if(gemstoneImage.includes(imageParam)){    
      diamondStockImage.push(gemstoneImage);
    }
  });
  
  if(diamond_image != '' && diamond_image != 'NA' && diamond_image != 'N/A' && diamond_image != 'None'){
    image += '<img class="tps-gemstonelist-detail-img" data-placeholder-img="" alt="'+gemstone_title+'" title="'+gemstone_title+'" src="'+diamond_image+'" onerror="imgError(this,`'+diamondStockImage[0]+'`);" width="300" height="300">';
  }else{    
    image += '<img class="tps-gemstonelist-detail-img" data-placeholder-img="" alt="'+gemstone_title+'" title="'+gemstone_title+'" src="'+diamondStockImage[0]+'" width="300" height="300">';        
  }
  return image;
}
/*** Gemstones Layout Start ***/

/*** selectRow function to compare diamond  ***/  
// function selectRow(row){
//     var firstInput = row.getElementsByTagName('input')[0];
//     firstInput.checked = !firstInput.checked;    
// }
/*** End ***/

/*** Change Diamond Listing View Grid/List ***/
function changeResultView(viewType){
  jQuery('.tps-result-view').removeClass('active');
  jQuery('.tps-'+viewType+'-view').addClass('active');  
  
  if(viewType == 'list'){
    jQuery('.tps-gemstone-list-view-container').css("display","block");
    jQuery('.tps-gemstone-grid-view-container').css("display","none");
    jQuery('.tps-sort-section').css("display","none");
  }else{
    jQuery('.tps-gemstone-grid-view-container').css("display","block");
    jQuery('.tps-gemstone-list-view-container').css("display","none");
    if(jQuery('.tps-all-diamonds-tab').hasClass('active-tab')){
      jQuery('.tps-sort-section').css("display","block");
    }else{
      jQuery('.tps-sort-section').css("display","none");
    }
  }

  updateSessionFilters(session_variable+'-other-data','View-Type', viewType);  
}
/*** End ***/

/*** Diamond List & Grid View Detail Info Ope Close ***/
function openCloseDetailInfo(gemstone_id,active_tab,display_type,action,ele) {    
  var active_tab = jQuery('#gemstone_active_tab').val();
  if(display_type == 'grid'){  
    if(action == 'open'){
      jQuery('.tps-gemstonelist-item-info').css("display", "none");
      jQuery('.tps-gemstone-info-'+gemstone_id).slideDown('slow');
    }else{
      jQuery('.tps-gemstone-detail-info-'+gemstone_id).slideUp('slow');
      jQuery('.tps-gemstone-info-'+gemstone_id).slideUp('slow');
    }      
  }else{
    
    if(jQuery('.diamond-list-item-'+gemstone_id).hasClass("diamond-row-active")){
      action = 'close';
    }
   
     var container = $(".tps-gemstonelist-item-quick-view-wrapper"); //diamond info container    
     // If the target of the click isn't the container
     if(!container.is(ele.target) && container.has(ele.target).length === 0){         
          if(action == 'open'){   
            jQuery('.tps-gemstonelist-detail-info').slideUp('slow'); 
            jQuery('.tps-gemstonelist-result-list-view-item').removeClass("diamond-row-active");
            
            jQuery('.diamond-list-item-'+gemstone_id).addClass("diamond-row-active"); 
            jQuery('.tps-gemstone-detail-info-'+gemstone_id).slideDown('slow'); 
            jQuery('.tps-gemstonelist-view-'+gemstone_id).removeClass('tps-arrow-down').addClass('tps-arrow-up');  

            var target = '.diamond-list-item-'+gemstone_id;
        
            //adjust scroll position when diamond info display        
            if(active_tab == 'recent' || active_tab == 'compare'){
              jQuery('html, body').animate({
                  scrollTop: jQuery(target).offset().top + 700
              }, 150); 
            }else{
              jQuery('html, body').animate({
                  scrollTop: jQuery(target).offset().top - 500
              }, 150); 
            }
               
            //end
            
          }else{
            jQuery('.table-data-view').removeClass("tps-arrow-up").addClass('tps-arrow-down');
            jQuery('.tps-gemstonelist-detail-info').css("display", "none");            
            jQuery('.diamond-list-row').removeClass("diamond-row-active");
          }
     }         
  }  
}
/*** End ***/

/*** Reset Filters Start ***/
function resetFilters(){
  var gemstone_type = jQuery('#gemstone_type').val();
  var session_variable = jQuery("#session_variable").val();
  localStorage.removeItem(session_variable+'-filters');   
  localStorage.setItem('resetFlag', 'true');
  jQuery(".tps-reset-filter-confirm-popup-div").hide();
  
  if(typeof(Storage) !== "undefined"){
    $('.tps-selected-filter-wrapper').hide();
    $('.tps-selected-filter-container ul').remove();
    
    $('.tps-filter-shape-li').removeClass('selected');
    $(".tps-filter-shape-checkbox").prop('checked', false);
    $('#gem_shape').val('');

    $('.tps-filter-fancy-color-li').removeClass('selected');
    $(".tps-filter-fancy-color-checkbox").prop('checked', false);
    $('#gem_fancy_color').val('');
    
    $('.tps-filter-report-li').removeClass('selected');
    $(".tps-filter-report-checkbox").prop('checked', false);
    $('#gem_report').val('');

    $('.tps-filter-type-li').removeClass('selected');
    $(".tps-filter-type-checkbox").prop('checked', false);
    $('#gem_type').val('');

    $('.tps-filter-treatment-li').removeClass('selected');
    $(".tps-filter-treatment-checkbox").prop('checked', false);
    $('#gem_treatment').val('');

    carat_slider_render(default_carat_min, default_carat_max, true, translations.titleCarat); 
    price_slider_render(default_price_min, default_price_max, true, translations.titlePrice);     
    clarity_slider_render(0, default_max_clarity, true, translations.titleClarity);   
    length_slider_render(default_length_min, default_length_max, true, translations.titleLength);
    width_slider_render(default_width_min, default_width_max, true, translations.titleWidth);

    $('#sort_dir').val('asc');    
    $('#sort_call').val('final_price');
    $('.tps-sort-option').removeClass('active');
    $('.final_price_asc').addClass('active');
    $('.tps-sort-icon').removeClass('tps-arrow-up').addClass('tps-arrow-down');
    jQuery('.tps-sort-by-value').html('<span>'+translations.titlePriceSortLowToHigh+'</span>');
    updateSessionFilters(session_variable+'-other-data','Sort-By', 'final_price');
    updateSessionFilters(session_variable+'-other-data','Sort-Direction', 'asc');
    
    jQuery('#page_no').val(1);
    jQuery('#pagination').val('');   
    graphqlDataCall();

    setTimeout(function(){
      localStorage.setItem('resetFlag','false');
    }, 1000);
  }
}
/*** End ***/

/*** Check Reset Flag Start ***/
function checkResetFlag() {
  var resetFlag = localStorage.getItem('resetFlag');
  return resetFlag;
}
/*** Check Reset Flag End ***/

/*** Get Closest Number From Array ***/
function getClosestNum(num, ar) {
  var i = 0,
    closest, closestDiff, currentDiff;
  if (ar.length) {
    closest = ar[0];
    for (i; i < ar.length; i++) {
      closestDiff = Math.abs(num - closest);
      currentDiff = Math.abs(num - ar[i]);
      if (currentDiff < closestDiff) {
        closest = ar[i];
      }
      closestDiff = null;
      currentDiff = null;
    }
      
    //returns first element that is closest to number
    return closest;
  }
  //no length
  return false;
}
/*** End ***/

/*** Get Array Index Value ***/  
function get_index(value, array) {
  var pos = 0
  for (i = 0; i < array.length; i++) {
    if (array[i] == value) {
      pos = i;
      break;
    }
  }
  return pos;
}
/*** End ***/

/*** Get Query Parameter Array from URL ***/
function getQueryMap(query) {
    if(typeof query !== 'string') {
       return null;
    }
    
    var toType = function(a) {
      return ({}).toString.call(a).match(/\s([a-zA-Z]+)/)[1].toLowerCase();
    }, map = {};
    
  // map the hit query into a proper object
  query.replace(/([^&|\?=]+)=?([^&]*)(?:&+|$)/g, function (match, key, value) {
      if (key in map) {
          // the key already exists, so we need to check if it is an array, if not, make it an array and add the new value
          if (toType(map[key]) !== 'array') {
              // it's not an array - make it an array
              map[key] = [map[key]];
          }
          // push the new value into the array
          map[key].push(value);
      } else {
          // put the value into the map
          map[key] = value;
      }
  });
  return map;
}
/*** End ***/

/*** Create & Update Session Filters Array Start ***/
function updateSessionFilters(arrayKey, filterKey, newValues) {
    // Retrieve the filters object from local storage or initialize an empty object
    let filters = JSON.parse(localStorage.getItem(arrayKey)) || {};

    // Split the newValues string by commas to handle multiple values
    let newValuesArray = newValues.split(',').map(value => value.trim());
 
    // Replace the old values with new ones
    filters[filterKey] = newValuesArray;
 
    // Save the updated filters object back to local storage
    localStorage.setItem(arrayKey, JSON.stringify(filters));
}
/*** Create & Update Session Filters Array End ***/

/*** Insert Session Selected Values In Input Fields Start ***/
function getSessionSelectedFilterValues(session_data) {  
  $.each(session_data, function(key,value){ 
    var inputKey = key.toLowerCase();
    
    if(key == 'Shape' || key == 'Report' || key == 'Colour' || key == 'Type' || key == 'Treatment' || key == 'Origin'){    
        if(value != ''){
          var inputValues = value.toString();
          if(key == 'Colour'){
            $('#gem_fancy_color').val(inputValues);
          }else{
            $('#gem_'+inputKey).val(inputValues);
          }
          
    
          var filterArrayKey = key;
          var filterArrayValues = value;
    
          setTimeout(function(){ 
            setSessionSelectedCheckBoxFilters(filterArrayKey,filterArrayValues);
          }, 50);  
        }
    }else if(key == 'Price' || key == 'Carat' || key == 'Length' || key == 'Width'){
      $('#'+inputKey+'_left_hidden').val(value[0]);
      $('#'+inputKey+'_right_hidden').val(value[1]);
    }else{            
      $('#'+inputKey+'_min_value').val(value[0]);
      $('#'+inputKey+'_max_value').val(value[1]);
    }    
  });    
}
/*** Insert Session Selected Values In Input Fields End ***/

/*** Set Session Selected Sort Filter Start ***/
function setSessionSelectedSortValues(sortBy,sortDirection) {  
  var sort_field_list = sortBy.replace('_', '-');
  
  if(sortDirection=="asc"){
      sort_order = translations.titleSortLowToHigh;
      jQuery('.tps-sort-icon-'+sort_field_list).addClass('tps-arrow-down').removeClass('tps-arrow-up');
  }else{
      sort_order = translations.titleSortHightToLow;
      jQuery('.tps-sort-icon-'+sort_field_list).removeClass('tps-arrow-down').addClass('tps-arrow-up');
  } 
  
  jQuery('.tps-sort-option').removeClass('active');
  var sort_field_grid = sortBy+'_'+sortDirection.toLowerCase();
  jQuery('.'+sort_field_grid).addClass('active');

  var sort_text = jQuery('.'+sort_field_grid).attr('value');
  jQuery('.tps-sort-by-value').html(sort_text);
}
/*** Set Session Selected Sort Filter End ***/

/*** Set Session Selected Checkbox Type Filters Start ***/
function setSessionSelectedCheckBoxFilters(filterKey,filterValues) {
  $(filterValues).each(function(index, value) {        
      var filterTitle = filterKey.toLowerCase();
      var filterValue = value.toLowerCase();
      filterValue = filterValue.replace(/\s+/g, '-');

      if(filterTitle == 'colour'){
        filterTitle = 'fancy-color';
      }
      
      $(".tps-filter-"+filterTitle+"-checkbox-"+filterValue).prop('checked', true);
      $(".tps-filter-"+filterTitle+"-"+filterValue).addClass('selected');
       
      var filterSelectedValues = filterKey+': '+value; 
      setSelectedFilter(filterSelectedValues,"remove"+filterKey+"Filter('"+value+"')",true,value);
   });  
}
/*** Set Session Selected Checkbox Type Filters End ***/

/*** Onclick Diamond Listing Grid Recent Diamond Detail Stored in Session Start ***/
$(document).on("click", ".tps-gemstonelist-result-grid-view-item a", function() {
  var gemstone_id = $(this).attr("data-id");  
  var diamond_page = $(this).attr("data-page");
  setRecentProductData(gemstone_id,diamond_page);
});
/*** Onclick Diamond Listing Grid Recent Diamond Detail Stored in Session End ***/

/*** Onclick Diamond Listing Recent Diamond Detail Stored in Session Start ***/
$(document).on("click", ".tps-gemstonelist-detail-view-btn", function() {
  var gemstone_id = $(this).attr("data-id");  
  var diamond_page = $(this).attr("data-page");
  setRecentProductData(gemstone_id,diamond_page);
});
/*** Onclick Diamond Listing Recent Diamond Detail Stored in Session End ***/

/*** Recently viewd Diamond Stored in Session Start ***/
function setRecentProductData(gemstone_id,diamond_page){
  //store single recently viewed diamond 
  updateSessionFilters(session_variable+'-other-data','Single-Recent-Gemstone', gemstone_id);
  updateSessionFilters(session_variable+'-other-data','Recent-Gemstone-Page-No', diamond_page);
  //end

  //store recently viewed Gemstones 
  var products_ids = '';
  if(session_other_data['Recent-Gemstones'] != null && session_other_data['Recent-Gemstones'] != ''){
    var products_ids = session_other_data['Recent-Gemstones'];
    products_ids = products_ids.toString();
  }
 
  var recentGemstonesData = [];
  if (products_ids == "" || products_ids == null) {
    var recent_diamonds = [];
  } else {
    recent_diamonds = products_ids.split(",");
  }

  if (jQuery.inArray(gemstone_id.toString(), recent_diamonds) == (-1)) {
    recent_diamonds.push(gemstone_id);
  }else{
    
  } 
  
  updateSessionFilters(session_variable+'-other-data','Recent-Gemstones', recent_diamonds.toString());
  //end  
}
/*** Recently viewd Diamond Stored in Session End ***/

/*** Get Recent Gemstones Tab Active Start ***/
function getRecentGemstones() {
  var session_other_data = JSON.parse(localStorage.getItem(session_variable+'-other-data'));
  
  if(session_other_data['Recent-Gemstones'] != null && session_other_data['Recent-Gemstones'] != undefined){
    var recentGemstones = session_other_data['Recent-Gemstones'].toString();
    var recentCount = session_other_data['Recent-Gemstones'].length;
    var ViewType = session_other_data['View-Type'][0];
    
    showLoader('recent');
    jQuery("#gemstone_active_tab").val('recent');
    jQuery(".tps-gemstone-result-data").hide();
    jQuery(".tps-recent-diamond-data").show();
    jQuery(".tps-listing-tabs").removeClass('active-tab');
    jQuery(".tps-recent-diamonds-tab").addClass('active-tab');
    getCompareRecentDataCall(recentGemstones,'recent');
  }else{
    alert(translations.titleRecentlyViewedGemstoneNotFound);
    return false;
  }  
}
/*** Get Recent Gemstones Tab Active End ***/

/*** Add Diamond For Compare ***/
function compareGemstones(id) {
  var session_other_data = JSON.parse(localStorage.getItem(session_variable+'-other-data'));
  var gemstone_name = jQuery('.diamond-checkbox-'+id).attr('data-gemstone-name');
  
  var compareArray = [];
  if(session_other_data != '' && session_other_data != null){
    if(session_other_data['Compare-Gemstones'] != null && session_other_data['Compare-Gemstones'] != ''){
      var compareArray = session_other_data['Compare-Gemstones'];
    }
  }

  if(jQuery.inArray(id.toString(),compareArray)==(-1)){
     if(jQuery('.diamond-checkbox-'+id).is(':checked')){
        compareArray.push(id); 
        jQuery('.diamond-compare-'+id).addClass('active');

         //display toast message when diamond added for compare
        jQuery('.tps-toast-msg-content').html(gemstone_name+' '+translations.titleAddedForCompare);           
         $(".tps-toast-msg-popup-wrapper").addClass("tps-popoup-show");
        setTimeout(function() { $(".tps-toast-msg-popup-wrapper").removeClass('tps-popoup-show'); }, 2000);

        if(jQuery('.tps-grid-view').hasClass('active')){        
          jQuery('.diamond-checkbox-'+id).prop('checked', true);   
        }
     }
  }else{
      compareArray.splice(compareArray.indexOf(id.toString()), 1);
      jQuery('.diamond-compare-'+id).removeClass('active');

      //display toast message when diamond remove from compare
      jQuery('.tps-toast-msg-content').html(gemstone_name+' '+translations.titleremovedFromCompare);
      $(".tps-toast-msg-popup-wrapper").addClass("tps-popoup-show");
      setTimeout(function() { $(".tps-toast-msg-popup-wrapper").removeClass('tps-popoup-show'); }, 2000);

      if(jQuery('.tps-grid-view').hasClass('active')){        
        jQuery('.diamond-checkbox-'+id).prop('checked', false);   
      }
  }
  
  updateSessionFilters(session_variable+'-other-data','Compare-Gemstones', compareArray.toString());
  
  var compareCount = compareArray.length;
  jQuery(".tps-compare-count").html("("+compareCount+")"); 
}
/*** End ***/

/*** Get Compare Gemstones Start ***/
function getCompareGemstones() {  
  jQuery('.tps-compare-diamond-data .tps-gemstonelist-result-list-view-items-list').removeClass('tps-no-diamonds-found');
  jQuery('.tps-compare-diamond-data .tps-gemstonelist-result-grid-view-items-list').removeClass('tps-no-diamonds-found');
  
  var session_other_data = JSON.parse(localStorage.getItem(session_variable+'-other-data'));
  if(session_other_data['Compare-Gemstones'] != null && session_other_data['Compare-Gemstones'] != undefined){
    var compareGemstones = session_other_data['Compare-Gemstones'].toString();
    var compareCount = session_other_data['Compare-Gemstones'].length;
    var ViewType = session_other_data['View-Type'][0];

    if(session_other_data['Compare-Gemstones'].length == 1 && session_other_data['Compare-Gemstones'][0] == ''){
      alert(translations.titleCompareGemstoneNotFound);
      return false;
    }
    
    showLoader('compare');
    jQuery("#gemstone_active_tab").val('compare');
    jQuery(".tps-gemstone-result-data").hide();
    jQuery(".tps-compare-diamond-data").show();
    jQuery(".tps-listing-tabs").removeClass('active-tab');
    jQuery(".tps-Compare-Gemstones-tab").addClass('active-tab');
    
    getCompareRecentDataCall(compareGemstones,'compare');    
  }else{
    alert(translations.titleCompareGemstoneNotFound);
    return false;
  }    
}
/*** Get Compare Gemstones End ***/

/*** Remove Gemstones From Compare Start ***/
function removeCompare(id) {  
  var active_tab = jQuery("#gemstone_active_tab").val(); 
  var session_other_data = JSON.parse(localStorage.getItem(session_variable+'-other-data'));
  if(session_other_data != '' && session_other_data != null){
    if(session_other_data['Compare-Gemstones'] != null && session_other_data['Compare-Gemstones'] != ''){
      var compareArray = session_other_data['Compare-Gemstones'];
    }
  }
  compareArray.splice(compareArray.indexOf(id.toString()), 1);
  
  var compareCount = compareArray.length;
  jQuery(".tps-compare-count").html("("+compareCount+")"); 
  
  updateSessionFilters(session_variable+'-other-data','Compare-Gemstones', compareArray.toString());    
  jQuery("[data-product-id='" + id + "']").prop('checked', false);

  if(compareCount == 0){    
     var gemListView = '<span class="tps-no-diamond-found">'+translations.titleGemstoneNotFoundForCompare+'</span>';
     var gemGridView = '<span class="tps-no-diamond-found">'+translations.titleGemstoneNotFoundForCompare+'</span>';

     jQuery('.tps-'+active_tab+'-diamond-data .tps-gemstonelist-result-list-view-items-list').addClass('tps-no-diamonds-found');
     jQuery('.tps-'+active_tab+'-diamond-data .tps-gemstonelist-result-grid-view-items-list').addClass('tps-no-diamonds-found');

     jQuery('.tps-'+active_tab+'-diamond-data .tps-gemstonelist-result-list-view-items-list').html(gemListView);
     jQuery('.tps-'+active_tab+'-diamond-data .tps-gemstonelist-result-grid-view-items-list').html(gemGridView);    
  }

  //display toast message when diamond remove from compare
  var gemstone_name = jQuery('.diamond-checkbox-'+id).attr('data-gemstone-name');
  jQuery('.tps-toast-msg-content').html(gemstone_name+' '+translations.titleremovedFromCompare);
  jQuery(".tps-toast-msg-popup-wrapper").addClass("tps-popoup-show");

  jQuery('.diamond-compare-'+id).removeClass('active');
  jQuery("[data-compare-id='"+id+"']").remove();

  setTimeout(function() { $(".tps-toast-msg-popup-wrapper").removeClass('tps-popoup-show'); }, 2000);
}
/*** Remove Gemstones From Compare End ***/

/*** Close Compare Message Popup Start ***/
function closePopup() {
  $(".tps-toast-msg-popup-wrapper").removeClass("tps-popoup-show");
}
/*** Close Compare Message Popup End ***/

/*** Graphql API Call To Get Diamond For Compare & Recent Gemstones Start ***/
function getCompareRecentDataCall(gemstone_data,flag) {       
  var active_tab = flag;
  jQuery('.tps-'+active_tab+'-diamond-data .tps-gemstonelist-result-list-view-items-list').html('');
  jQuery('.tps-'+active_tab+'-diamond-data .tps-gemstonelist-result-grid-view-items-list').html('');
  
  //query parameters for graphql call
  var postdata = JSON.stringify({
      query: `{
                  ${gemstoneDetailApi}(gemstoneId: "` + gemstone_data +`")
                  {                    
                   gemstone{
                    gemstoneId 
                    shape 
                    caratWeight  
                    color 
                    fancyColor
                    fancyColorIntensity
                    fancyColorOvertone
                    clarity 
                    cut 
                    symmetry 
                    polish 
                    deptPerc 
                    tablePerc 
                    length 
                    width 
                    depth 
                    ratio 
                    measurement 
                    girdle 
                    girdleMin 
                    girdleMax 
                    girdleCondition 
                    culet 
                    culetCondition  
                    flourIntensity  
                    certificateFile 
                    lab  
                    finalPrice  
                    certificateNumber 
                    stockNumber 
                    gemstoneImage  
                    gemstoneVideo  
                    gemstoneType 
                    currencyCode 
                    currencySymbol 
                    treatment
                    measurement
                   }
                  }
                  }
                  `
    });
    abortAjax(xhr);  
    xhr = jQuery.ajax({ 
        url: api,
        contentType: "application/json",
        type: 'POST',
        data: postdata,
        success: function(response) {
            var allGemstoneData = response.data[gemstoneDetailApi].gemstone;            
            if(active_tab == 'recent'){
              jQuery('.tps-'+active_tab+'-diamond-data .table-head-compare').remove();
            }else{
              jQuery('.tps-'+active_tab+'-diamond-data .table-head-compare').html(translations.titleRemove);
            }
          
            var gemListView = '';
            var gemGridView = '';            
            
            $.each(allGemstoneData, function(i, gemstoneData) { 
               gemListView += getGemstoneListingViewLayout(gemstoneData,'',active_tab);
               gemGridView += getGemstoneListingGridLayout(gemstoneData,'',active_tab,i);
            });                       

            jQuery('.tps-'+active_tab+'-diamond-data .tps-gemstonelist-result-list-view-items-list').html(gemListView);
            jQuery('.tps-'+active_tab+'-diamond-data .tps-gemstonelist-result-grid-view-items-list').html(gemGridView);

            jQuery('.tps-'+active_tab+'-diamond-data .tps-gemstonelist-result-list-view-loader').hide();
            jQuery('.tps-'+active_tab+'-diamond-data .tps-gemstonelist-result-grid-view-loader').hide();
        }
    });

}
/*** End ***/

/*** Get All Gemstones Tab Active ***/ 
function getAllGemstones(){
  jQuery("#gemstone_active_tab").val('all');
  jQuery(".tps-gemstone-result-data").hide();
  jQuery(".tps-all-diamond-data").show();
  jQuery(".tps-listing-tabs").removeClass('active-tab');
  jQuery(".tps-all-diamonds-tab").addClass('active-tab');
}
/*** End ***/

/*** Refine Your Results Focus To Filter Section ***/
function refineYourResults(){
  var target = '.tps-filter-container'; 
  $('html, body').animate({
        scrollTop: $(target).offset().top - 250
  }, 'slow'); 
}
/*** End ***/

function createDiamondProduct(element, gemstoneType){    
  
  //jQuery("#tps_add_diamond_to_wishlist").addClass('tps-loading');
  const gemstone_id = element.getAttribute('data-id');
   var gemstone_image = element.getAttribute('data-img');
      
  //query parameters for graphql diamond add to cart call
  var postdata = JSON.stringify({ query:`{
                  ${gemstoneAddToCart}(gemstoneId: "` +
              gemstone_id +
              `",gemstoneImage:"` +
              gemstone_image +
              `")
                  {      
                    status
                     code
                     message                       
                     productId
                     variantId                     
                  }
                  }
                  `});     

     jQuery.ajax({
      url:api,
      contentType: "application/json",
      type:'POST',
      data: postdata,
      success: function(response) { 
        // if(diamond_type == 'white'){
        //   var productId = response.data.rapnetDiamondAddToCart.productId;  
        // }else{
        //   var productId = response.data.gemstoneAddToCart.productId;       
        // }
         var productId = response.data.gemstoneAddToCart.productId;  
        setTimeout(function(){ 
            addRemoveProductToWishlist(productId,'diamond');
            jQuery("#tps_add_diamond_to_wishlist").removeClass('tps-loading');
            
        }, 1500); 
      },
      error: function (xhr, ajaxOptions, thrownError) {
         alert(xhr.status);
         alert(thrownError);           
         jQuery("#tps_add_diamond_to_wishlist").removeClass('tps-loading');
       }
    }); 
}
/*** End ***/